<script>
	import { onDestroy, onMount, tick } from "svelte";
	import { navigateTo } from "svelte-router-spa";
	import { PRConnect } from "@projectroom/ui-lib";
	import { _ } from "svelte-i18n";
	import axios from "axios";
	import { identity } from "svelte/internal";
	import { iframeRefStore } from "./store/iframe-store.js";
	import { planStore } from "./store/plan-store";
	import ChatBubbleColorPicker from "./ChatBubbleColorPicker.svelte";
	import { getContext } from "svelte";
	import {
		isPublishPopup,
		isRevision,
		saveStatus,
		markSaving,
		markSaved,
		markSaveIdle,
	} from "./store/builder-store.js";
	import { moveFolder, chatAssetFolder } from "./chat-builder/imageAssetApi";
	import { normalizeCollectKeys, normalizeTraits } from "./chat-builder/learnerDecls";
	import { readReply } from "./chat-builder/replyStyles";
	import ProfileContext from "./chat-builder/ProfileContext.svelte";
	import ChatTemplateSelect from "../components/ChatTemplateSelect.svelte";
	import ScenePromptContextList from "./chat-builder/ScenePromptContextList.svelte";
	import ScenePromptEditPopup from "./chat-builder/ScenePromptEditPopup.svelte";
	import AIImagePopup from "./chat-builder/AIImagePopup.svelte";
	import DetailContext from "./chat-builder/DetailContext.svelte";
	import LoadingPopup from "./chat-builder/LoadingPopup.svelte";
	import PublishContext from "./chat-builder/PublishContext.svelte";
	import ConversationSettingsContext from "./chat-builder/ConversationSettingsContext.svelte";
	import BlockContext from "./chat-builder/BlockContext.svelte";
	import FormSubmissionsContext from "./chat-builder/FormSubmissionsContext.svelte";
	import BlockResponsesPanel from "./chat-builder/BlockResponsesPanel.svelte";
	import { Tabs } from "../lib/ui";
	import BuilderSidebar from "./chat-builder/shell/BuilderSidebar.svelte";
	import { V3_ONLY_TABS } from "./chat-builder/shell/tabs";
	import BuilderTopTabs from "./chat-builder/shell/BuilderTopTabs.svelte";
	import Plan from "../components/Plan.svelte";
	import {
		showLoadingPopup,
		hideLoadingPopup,
	} from "./store/loadingPopupStore.js";

	export let currentRoute;
	export let params;
	// 게시는 레이아웃(ChatBuilderLayout)이 소유한다 — 상단 "AI챗 생성"/"게시하기" 버튼이 이걸 호출.
	let clickPosting = getContext("clickPosting");

	let chatId;
	let imageLoadingPopupFlag;
	let imageDownloadingPopupFlag;
	let promptGeneratePopupFlag;
	let popupPostingFlag;
	let chat;
	let isLoaded;
	let addRefenceImageRef, addRefenceBackImageRef;
	let refProfileChatBack, refUserChatBack;
	let refIframe;
	let refProfileImageContext, refBackImageContext;
	let isProfileImageAIPopup;
	let isBackImageChecked, isProfileImageChecked;
	let isAIImagePopup;
	let imageType;
	// 미리보기 패널: 넓은 화면은 사이드로 항상 표시, 좁은 화면(≤1024px)은 오버레이 드로어로 on/off.
	let previewOpen = true;
	let isNarrow = false; // ≤1024px → 프리뷰를 드로어로
	// 미리보기 패널 탭: 'preview'(iframe) | 'responses'(활성 폼 블록의 응답).
	// 블록 탭에서 폼 블록을 포커스하면(BlockContext가 chat.responsesBlockId 지정) '응답' 탭이 뜬다.
	let previewPanelTab = "preview";
	$: canShowResponses = chat?.currentTab === "block" && !!chat?.responsesBlockId;
	$: showResponses = canShowResponses && previewPanelTab === "responses";
	let isSceneImageAIPopup;
	let scenePromptContext;
	let profileAIImageList = [];
	let backAIImageList = [];
	let sceneAIImageList = [];
	let aiImageLists = {
		profile: [],
		background: [],
		scene: [],
	};
	let refProfileAIImage = [];
	let imageRefSources = {
		profile: { src: "", keywordList: [] },
		background: { src: "", keywordList: [] },
		scene: { src: "", keywordList: [] },
	};
	let imageRefNames = {};
	let refSubtitle;
	let categoryList = [];
	let profileRefKeywordList = [];
	let backgroundRefKeywordList = [];
	let isEditableProfilekeyword,
		isEditableBackgroundKeyword,
		isEditablePersonaKeyword;
	// 게시(=AI챗 생성) 가 필수값 때문에 막혔을 때 버튼 옆에 띄우는 안내.
	// 이 두 값을 화면에 그리는 곳이 없으면 "눌러도 아무 일이 없는" 버튼이 된다.
	let isTooltipShow = false;
	let tooltipContext = "";
	let tooltipTimer;
	const showBlockedTooltip = (message) => {
		tooltipContext = message;
		isTooltipShow = true;
		clearTimeout(tooltipTimer);
		tooltipTimer = setTimeout(() => (isTooltipShow = false), 3000);
	};
	let newProfileKeyword, newBackgroundKeyword;
	let characterPersonaRefKeywordList = [];
	// (제거됨) 추천 키워드 리스트 — AI 이미지 생성이 키워드 방식에서 선택지 위저드로 바뀌며 미사용.

	let characterPersonaRequiredKeywordList = [
		"귀여운 성격",
		"밝은 성격",
		"싸가지 없는 말투",
		"순수한 성격",
		"따뜻한 말투",
	];
	let characterPersonaKeywordList = [
		// 말투
		"단호한 말투",
		"부드러운 말투",
		"상냥한 말투",
		"퉁명스러운 말투",
		"시니컬한 말투",
		"경박한 말투",
		"느릿느릿한 말투",
		"직설적인 말투",
		"비꼬는 말투",
		"애교 있는 말투",
		"권위적인 말투",
		"도도한 말투",
		"우아한 말투",
		"투덜거리는 말투",
		"가식적인 말투",
		"쾌활한 말투",
		"무뚝뚝한 말투",
		"따뜻한 말투",
		"거친 말투",
		"명령조의 말투",
		"냉소적인 말투",
		"애매한 말투",
		"거만한 말투",
		"조용한 말투",
		"시끄러운 말투",
		"속삭이는 말투",
		"약간 혀 꼬인 말투",
		"방정맞은 말투",
		"사근사근한 말투",
		"서늘한 말투",
		"빈정대는 말투",
		"다정한 말투",
		"수다스러운 말투",
		"공격적인 말투",
		"낭랑한 말투",
		"무심한 말투",
		"짧고 간결한 말투",
		"어리둥절한 말투",
		"잔잔한 말투",
		"차분한 말투",
		"애매모호한 말투",
		"감정적인 말투",
		"화려한 말투",
		"경쾌한 말투",
		"신경질적인 말투",
		"논리적인 말투",
		"비판적인 말투",
		"겁먹은 말투",
		"활기찬 말투",
		"냉정한 말투",
		"지적인 말투",
		"유쾌한 말투",
		"충격적인 말투",
		"격정적인 말투",
		"성난 말투",
		"단조로운 말투",
		"호탕한 말투",
		"위엄 있는 말투",
		"경청하는 말투",
		"날카로운 말투",
		"거칠고 소란스러운 말투",
		"매서운 말투",
		"둥글둥글한 말투",
		"나긋나긋한 말투",
		"엄숙한 말투",
		"흐릿한 말투",
		"꺼리낌 없는 말투",
		"까칠한 말투",
		"들떠 있는 말투",
		"조급한 말투",
		"천진난만한 말투",
		"혼란스러운 말투",
		"격식 있는 말투",
		"무례한 말투",
		"점잖은 말투",
		"당황한 말투",
		"귀찮아하는 말투",
		"신중한 말투",
		"타협적인 말투",
		"겸손한 말투",
		"꺼칠한 말투",
		"뻔뻔한 말투",
		"침착한 말투",
		"공격적이지 않은 말투",
		"애정 어린 말투",
		"분노에 찬 말투",
		"경멸하는 말투",
		"낙관적인 말투",
		"차가운 말투",
		"속마음을 숨기는 말투",
		"시시덕거리는 말투",
		"설득력 있는 말투",
		"장난스러운 말투",
		"의기양양한 말투",
		"터무니없는 말투",
		"경쾌하고 빠른 말투",
		"비통한 말투",
		"교양 있는 말투",
		"위트 있는 말투",
		"복잡한 말투",
		// 성격
		"섹시한 성격",
		"차가운 성격",
		"냉정한 성격",
		"유머러스한 성격",
		"소심한 성격",
		"용감한 성격",
		"겁이 많은 성격",
		"당돌한 성격",
		"순진한 성격",
		"계산적인 성격",
		"야망 있는 성격",
		"이기적인 성격",
		"이타적인 성격",
		"진중한 성격",
		"가벼운 성격",
		"쿨한 성격",
		"귀여운 성격",
		"도도한 성격",
		"츤데레 성격",
		"깐깐한 성격",
		"느긋한 성격",
		"성급한 성격",
		"독설적인 성격",
		"다정한 성격",
		"무뚝뚝한 성격",
		"신경질적인 성격",
		"친절한 성격",
		"까칠한 성격",
		"자상한 성격",
		"까불거리는 성격",
		"유식한 성격",
		"무지한 성격",
		"지적인 성격",
		"엉뚱한 성격",
		"냉소적인 성격",
		"이상주의적인 성격",
		"현실적인 성격",
		"낭만적인 성격",
		"비관적인 성격",
		"긍정적인 성격",
		"비판적인 성격",
		"감성적인 성격",
		"논리적인 성격",
		"직설적인 성격",
		"애교 많은 성격",
		"터프한 성격",
		"고집 센 성격",
		"순응적인 성격",
		"신비로운 성격",
		"사교적인 성격",
		"외향적인 성격",
		"내성적인 성격",
		"무례한 성격",
		"예의 바른 성격",
		"낙천적인 성격",
		"염세적인 성격",
		"적극적인 성격",
		"수줍은 성격",
		"사려 깊은 성격",
		"감정 기복이 심한 성격",
		"차분한 성격",
		"활발한 성격",
		"성실한 성격",
		"게으른 성격",
		"불안한 성격",
		"자신감 있는 성격",
		"우울한 성격",
		"생기 넘치는 성격",
		"시니컬한 성격",
		"호탕한 성격",
		"유연한 성격",
		"뻔뻔한 성격",
		"의리 있는 성격",
		"똑똑한 성격",
		"무모한 성격",
		"참을성 있는 성격",
		"참을성 없는 성격",
		"침착한 성격",
		"거침없는 성격",
		"꼼꼼한 성격",
		"철두철미한 성격",
		"장난기 많은 성격",
		"예민한 성격",
		"허세 있는 성격",
		"의욕적인 성격",
		"복수심 강한 성격",
		"대담한 성격",
		"눈치 빠른 성격",
		"느리지만 꼼꼼한 성격",
		"변덕스러운 성격",
		"염려 많은 성격",
		"조용한 성격",
		"의심 많은 성격",
		"철학적인 성격",
		"직관적인 성격",
	];
	let isCreepong;

	const DEFAULT_PROMPT_PRIMARY_OPTION_ID = 1;
	const DEFAULT_PROMPT_SECONDARY_OPTION_ID = 1;

	let currentTab = "info";
	const tabList = [
		{ label: "기본 정보", value: "info", required: true },
		{ label: "상세 정보", value: "detail", required: true },
		{ label: "이미지 에셋", value: "scene", required: false },
		// { label: '키워드북', value: 'keywordbook', required: false },
		// { label: '단계설정', value: 'step', required: false },
		// 대화 설정 = 챗 전체 설정(용도·학습자 정보·수집 항목·유도 방식·쓰는 말/받아 주기). [블록]은 콘텐츠만.
		{ label: "대화 설정", value: "conversation", required: false },
		{ label: "블록", value: "block", required: false },
		{ label: "게시설정", value: "publish", required: true },
		{ label: "응답", value: "submissions", required: false },
	];

	// 콘텐츠 헤더에 표시할 현재 탭 라벨 (chat 재할당 시 갱신)
	$: currentTabLabel = chat
		? (tabList.find((t) => t.value === chat.currentTab) || {}).label || ""
		: "";

	onMount(async () => {
		chatId = currentRoute.namedParams.chatId;
		// 먼저 유저 스토어 초기화
		await planStore.init();
		PRConnect.send("/api/Chat/getChatInfo", { chatId }, async (data) => {
			if (data.header.status === "success") {
				const chatInfo = data.result.chatInfo;
				chat = new Chat({
					...chatInfo,
					promptOptionList: data.result.promptOptionList,
					promptOptionHistory: data.result.promptOptionHistory,
					aiImageList: data.result.aiImageList,
					scenePromptContextList: data.result.scenePromptContextList,
				});
				categoryList = data.result.categoryList;
				chat.assign();
				isLoaded = true;
				await tick();
				jQuery(".lite-wrap").parent().scrollTop(0);
				iframeRefStore.set(refIframe);
				isCreepong = planStore.isCreepong();
			}
		});
	});

	const shuffleArray = (array, size = array.length, target) => {
		const shuffled = array
			.map((value) => ({ value, sort: Math.random() }))
			.sort((a, b) => a.sort - b.sort)
			.map(({ value }) => value);
		if (target === "persona") {
			const uniqueKeywordList =
				characterPersonaRequiredKeywordList.filter(
					(e) => !characterPersonaRefKeywordList.includes(e),
				);
			shuffled.push(...uniqueKeywordList);
		}
		return shuffled.slice(-size);
	};

	const onImageFileUpload = (
		e,
		path,
		target,
		loadingType = "imageUpload",
	) => {
		let image = e.target.files[0];
		const key = `chats/${chat.chatId}/common/${path}/${image.name}`;
		const type = image.type;
		showLoadingPopup(loadingType);
		PRConnect.send(
			"/api/File/uploadPresignedUrl",
			{ key, type },
			(data) => {
				axios
					.put(data.result, image, {
						headers: { "Content-Type": type },
					})
					.then((response) => {
						chat.change(target, image.name);
						hideLoadingPopup();
					});
			},
		);
	};

	const onRefenceImageFileUpload = (e, path, target) => {
		let image = e.target.files[0];
		const key = `chats/${chatId}/common/${path}/${image.name}`;
		const type = image.type;
		imageLoadingPopupFlag = true;
		const reader = new FileReader();
		reader.onload = function (event) {
			imageRefSources[target].src = event.target.result;
			imageRefSources = { ...imageRefSources };
		};

		PRConnect.send(
			"/api/File/uploadPresignedUrl",
			{ key, type },
			(data) => {
				axios
					.put(data.result, image, {
						headers: { "Content-Type": type },
					})
					.then((response) => {
						imageLoadingPopupFlag = false;
						reader.readAsDataURL(image);
						imageRefNames[path] = key;
						PRConnect.send(
							"/api/Chat/gptImageDescription",
							{ referenceImage: key },
							(data) => {
								if (data.header.status === "success") {
									if (target === "profile") {
										profileRefKeywordList = JSON.parse(
											data.result,
										);
									} else {
										backgroundRefKeywordList = JSON.parse(
											data.result,
										);
									}
								}
							},
						);
					});
			},
		);
	};

	class Chat {
		constructor({
			chatId,
			title = "",
			subTitle = "",
			characterUniverse = "",
			characterPersona = "",
			characterPersonaKeyword,
			characterMessage = "",
			profileImageContent,
			profileAssetId = null,
			profileAssetUrl = null,
			backImageContent,
			backImageCss,
			backAssetId = null,
			backAssetUrl = null,
			logoImageContent,
			logoAssetId = null,
			logoAssetUrl = null,
			allowedOrigins = null,
			characterImageContent,
			linkUrl = "",
			profileChatCss,
			userChatCss,
			fixedButtonCss,
			fixedButtonList,
			useFixedButton = "N",
			randomMessageFlag,
			aiImageFlag,
			additionalMessageFlag,
			additionalMessage = "",
			category = "01",
			revisionFlag = "N",
			postFlag = "N",
			primaryOptionId,
			secondaryOptionId,
			promptOptionList,
			promptOptionHistory,
			aiImageList,
			scenePromptContextList,
			categoryList,
			chatType = "CHARACTER",
			useRag = "N",
			ragText = "",
			ragStrict = "N",
			useVectorRag = "N",
			chatVersion = "V2",
			useBlock = "N",
			ttsFlag = "N",
			sttFlag = "N",
			sttOnly = "N",
			sttOnlyEdit = "Y",
			sttOnlyScope = "all",
			voiceHandsfree = "Y",
			sttStartWaitMs = null,
			sttEndPauseMs = null,
			ttsModel = "",
			ttsVoice = "",
			ttsInstructions = "",
			sttLanguage = "",
			sttModel = "",
			guideStyle = null,
			replyStyle = null,
			aiModel = "",
			collectKeys = null,
			traits = null,
			purpose = "normal",
		}) {
			this.currentTab = "info";
			this.chatId = chatId;
			this.title = title;
			this.subTitle = subTitle;
			this.characterUniverse = characterUniverse;
			this.characterPersona = characterPersona;
			// this.characterPersonaKeyword = JSON.parse(characterPersonaKeyword);
			// this.characterPersonaRefKeywordList = this.characterPersonaKeyword;
			this.characterMessage = characterMessage;
			this.chatType = chatType;
			this.chatVersion = chatVersion;
			this.useBlock = useBlock;
			this.profileImageContent = profileImageContent;
			// 프로필/배경도 로고와 동일한 이미지 자산(ref) 체계. 저장은 assetId만, 표시 URL은
			// 서버가 조인해 내려준 current 버전(profile/backAssetUrl). 레거시 파일명은 폴백.
			this.profileAssetId = profileAssetId;
			this.profileAssetUrl = profileAssetUrl;
			this.backImageContent = backImageContent;
			this.backAssetId = backAssetId;
			this.backAssetUrl = backAssetUrl;
			this.backImageCss = new BackImageCss({
				...JSON.parse(backImageCss),
			});
			this.logoImageContent = logoImageContent;
			// 상단 로고 = 이미지 자산(ref). 저장은 assetId만, 표시는 서버가 조인해 내려준 current 버전 URL.
			// (logoImageContent는 에셋 도입 전 챗을 위한 레거시 폴백)
			this.logoAssetId = logoAssetId;
			this.logoAssetUrl = logoAssetUrl;
			// 임베드 위젯을 띄울 수 있는 도메인(개행 구분). 비면 제한 없음.
			this.allowedOrigins = allowedOrigins;
			this.characterImageContent = characterImageContent;
			this.linkUrl = linkUrl;
			this.profileChatCss = new ChatCss({
				...JSON.parse(profileChatCss),
			});
			this.userChatCss = new ChatCss({ ...JSON.parse(userChatCss) });
			this.fixedButtonCss = new ChatCss({
				...(fixedButtonCss
					? JSON.parse(fixedButtonCss)
					: { color: "#F7528A" }),
			});
			this.fixedButtonList = fixedButtonList ? JSON.parse(fixedButtonList) : [];
			this.useFixedButton = useFixedButton;
			this.randomMessageFlag = randomMessageFlag;
			this.aiImageFlag = aiImageFlag;
			this.additionalMessageFlag = additionalMessageFlag;
			this.additionalMessage = additionalMessage;
			this.category =
				category == null
					? chatType === "ENTERPRISE"
						? "ENTERPRISE"
						: "01"
					: category;
			this.setRevisionFlag(revisionFlag);
			this.postFlag = postFlag;
			this.updateRequiredFields();
			this.primaryOptionId = primaryOptionId;
			this.secondaryOptionId = secondaryOptionId;
			this.transformOptionsData(promptOptionList, promptOptionHistory);
			this.splitAIImageListByType(aiImageList);
			this.setScenePromptContextList(scenePromptContextList);
			this.categoryList = categoryList;
			this.useRag = useRag;
			this.ragText = ragText ?? "";
			this.ragStrict = ragStrict ?? "N";
			this.useVectorRag = useVectorRag ?? "N";
			this.uploadedDocs = [];
			this.isDocLoaded = false;
			// 음성 채팅(V3 런타임 전용) — 읽어주기(TTS)/음성입력(STT). 상위 요금제(PRO+) 전용 게이팅은
			// PublishContext에서 planStore.isProOrAbove()로 처리. 여기선 챗별 on/off 값만 보관·저장.
			this.ttsFlag = ttsFlag ?? "N";
			this.sttFlag = sttFlag ?? "N";
			// 음성 전용 입력. "Y"면 엔드유저 화면에서 텍스트 입력창을 없애고 말해서만 입력하게 한다.
			// STT가 꺼져 있으면 의미가 없다(입력 수단이 하나도 없어짐) → 빌더가 STT 켜짐일 때만 열어 준다.
			this.sttOnly = sttOnly ?? "N";
			// 음성 전용 구간에서 받아쓴 문장을 키보드로 고칠 수 있게 할지. 기본은 허용 —
			// STT 오인식·마이크 불량으로 학습자가 갇히는 쪽이, 몇 명이 타이핑하는 쪽보다 나쁘다.
			// (손댄 발화는 CHAT_LOG.INPUT_MODE에 'voice-edited'로 남아 저작자가 구분할 수 있다)
			this.sttOnlyEdit = sttOnlyEdit ?? "Y";
			// 음성 전용을 거는 구간. "all"=챗 전체(기존 동작), "step"=수업(유도/평가 스텝) 중에만,
			// "free"=자유 대화에서만. 수업은 말하기로 시키고 질문은 타이핑하게 두는 저작을 위한 값.
			this.sttOnlyScope = sttOnlyScope ?? "all";
			// 봇이 답변을 다 읽어 준 뒤 마이크를 자동으로 열지(듣고 → 바로 대답). "N"이면 직접 눌러서만 말한다.
			// 강제가 아니라 '자동 열기'다 — 꺼도 [눌러서 말하기]는 그대로 있다. 읽어주기(TTS)가 켜져 있고
			// 음성 전용이 걸린 구간에서만 의미가 있다.
			this.voiceHandsfree = voiceHandsfree ?? "Y";
			// 녹음 자동 종료 시간(ms). null = 런타임 기본(첫마디 대기 4초 / 말 끝 대기 1.5초).
			// 학습자마다 생각하며 말하는 속도가 달라 챗마다 고칠 수 있게 했다(빨라야 하는 챗은 0.7초).
			this.sttStartWaitMs = sttStartWaitMs ?? null;
			this.sttEndPauseMs = sttEndPauseMs ?? null;
			// 읽어주기(TTS) 모델 선택. "" = 서버 기본(OpenAI tts-1). 빌더에선 모델 선택 UI를 감추고 기본만 쓴다.
			this.ttsModel = ttsModel ?? "";
			// 읽어주기(TTS) 목소리 선택. "" = 서버 기본(alloy). 예: "nova", "echo", "onyx".
			this.ttsVoice = ttsVoice ?? "";
			// 읽어주기(TTS) 말투 = OpenAI instructions 로 나가는 연기 지시("어린이처럼 밝고 높은 톤으로" 등).
			// "" 이면 지시 없이 읽는다. 값이 있으면 서버가 모델을 gpt-4o-mini-tts 로 올려 그 톤으로 생성한다.
			// (톤·속도·억양이 바뀌는 것이고, 성인 화자의 음색 자체가 아이로 바뀌진 않는다.)
			this.ttsInstructions = ttsInstructions ?? "";
			// 음성 입력(STT) 인식 언어. "" = 한국어(기존 동작), "auto" = 자동 감지, "en"/"ja"… = 강제.
			// Whisper의 language는 힌트가 아니라 강제라, 영어 수업 챗을 한국어로 두면 영어가 한글로 받아적힌다.
			this.sttLanguage = sttLanguage ?? "";
			// 음성 입력(STT) 모델. "" = 서버 기본(env stt_model || whisper-1).
			this.sttModel = sttModel ?? "";
			// ⑨ 유도 스텝 기본 "유도 방식"(스탠스). null/""=미설정→서버 minimal. 스텝이 completion.guideStyle로 개별 오버라이드.
			this.guideStyle = guideStyle ?? null;
			// ⑨ 학습자 말 받아 주기 챗 기본값 {language, mistakes, otherLanguage, short, offTopic} (CHATS.REPLY_STYLE, JSON).
			//    JSON 컬럼이라 문자열로 올 수도 있다. 저장은 `...this` 로 객체째 나가고 서버가 정리한다(modifyChat).
			this.replyStyle = readReply(replyStyle);
			// 챗별 답변 모델(CHATS.AI_MODEL). "" = 서버 전역 설정. 선택지는 chat-builder/aiModels.js(서버 aiModel.js 미러).
			this.aiModel = aiModel ?? "";
			// ⑨ 수집 항목: 대화에서 캐치해 학습자 단위로 남길 키 목록 [{key, desc}].
			//    JSON 컬럼이라 문자열로 올 수도 객체로 올 수도 있다(mysql2 드라이버 차이) → 배열로 정규화.
			const parseKeyList = (v) => {
				const raw = typeof v === "string" ? (() => { try { return JSON.parse(v); } catch { return []; } })() : v;
				return Array.isArray(raw) ? raw.filter((it) => it && it.key) : [];
			};
			this.collectKeys = parseKeyList(collectKeys);
			// 사전 설정: 이 챗이 학습자 프로필과 맺는 관계 [{key, desc, write, guide}].
			//    write=이 챗이 대화에서 잡아 남긴다 / guide=이 값에 따라 말하는 방식을 바꾼다.
			//    ⚠️ write 선언이 있어야만 저장된다 — 다른 챗이 남긴 값을 '읽는' 데는 선언이 필요 없다.
			this.traits = parseKeyList(traits);
			// 챗 용도(normal | intake | exit). 이 값 하나가 콘텐츠 탭이 무엇을 보여줄지를 정한다 —
			// 테스트 챗에 자유 블록·플로우·코스 뷰는 잡음이라 아예 감춘다.
			this.purpose = ["intake", "exit"].includes(purpose) ? purpose : "normal";
		}

		isCharacterChat() {
			return this.chatType === "CHARACTER";
		}

		isEnterpriseChat() {
			return this.chatType === "ENTERPRISE";
		}

		updateRequiredFields() {
			// tab = 그 필드를 입력하는 화면. 게시가 막히면 여기로 데려다 준다.
			this.requiredFields = [
				{
					name: "title",
					displayContext: "이름을 작성해야",
					value: this.title,
					tab: "info",
				},
				{
					name: "profileImageContent",
					displayContext: "이미지를 올려야",
					// 에셋으로 지정된 경우 profileImageContent는 비어 있으므로 getter(에셋 우선)로 판정.
					value: this.getProfileImageContent(),
					tab: "info",
				},
				{
					name: "subTitle",
					displayContext: "소개글을 작성해야",
					value: this.subTitle,
					tab: "info",
				},
				...(this.isEnterpriseChat()
					? []
					: [
							{
								name: "characterUniverse",
								displayContext: "설명을 작성해야",
								value: this.characterUniverse,
								tab: "detail",
							},
						]),
				{
					name: "characterPersona",
					displayContext: "프롬프트를 작성해야",
					value: this.characterPersona,
					tab: "detail",
				},
				...(this.isCharacterChat()
					? [
							{
								name: "category",
								displayContext: "카테고리를 지정해야",
								value: this.category,
								tab: "publish",
							},
						]
					: []),
			];
			this.requiredPromptFields = [
				{ name: "title", value: this.title },
				{ name: "subTitle", value: this.subTitle },
				{ name: "characterUniverse", value: this.characterUniverse },
			];
		}

		splitAIImageListByType(aiImageList) {
			aiImageList.forEach((image) => {
				const type = image.imageType?.toLowerCase();
				if (type === "profile") {
					profileAIImageList.push(image);
					profileAIImageList = [...profileAIImageList];
				} else if (type === "background") {
					backAIImageList.push(image);
					backAIImageList = [...backAIImageList];
				} else if (type === "scene") {
					sceneAIImageList.push(image);
					sceneAIImageList = [...sceneAIImageList];
				}
			});

			// temp 배열로 분리
			const tempLists = {
				profile: [],
				background: [],
				scene: [],
			};

			// 컴포넌트로 분리하여 동기화를 위해 객체로 감싸서 props로 보내기 위한 첫 작업
			aiImageList.forEach((image) => {
				const type = image.imageType?.toLowerCase();
				if (type in tempLists) {
					tempLists[type].push(image);
				}
			});

			// 마지막에 한 번만 재할당 (반응성 트리거 목적)
			aiImageLists = {
				profile: tempLists.profile,
				background: tempLists.background,
				scene: tempLists.scene,
			};
		}

		// 값이 늘 문자열이라는 보장이 없다(카테고리처럼 숫자로 오는 필드가 있다).
		// 예전엔 여기서 .trim() 이 터지면 doPost() 가 통째로 죽어 버튼이 먹통이 됐다.
		isBlankField(field) {
			return String(field.value ?? "").trim() === "";
		}

		checkRequiredFields() {
			let isRequired = false;
			this.updateRequiredFields();
			this.requiredFields.some((field) => {
				if (this.isBlankField(field)) {
					isRequired = true;
					showBlockedTooltip(
						`${this.isCharacterChat() ? "캐릭터 " : ""}${field.displayContext} AI챗을 생성 할 수 있어요!`,
					);
					// 안내만 하고 끝내면 어디를 고쳐야 하는지 알 수 없다 → 해당 탭으로 이동.
					if (field.tab) this.changeCurrentTab(field.tab);
					return true;
				}
			});
			return isRequired;
		}

		checkRequiredPromptFields() {
			let isRequired = false;
			this.updateRequiredFields();
			this.requiredPromptFields.some((field) => {
				if (this.isBlankField(field)) {
					isRequired = true;
					showBlockedTooltip(
						"캐릭터 이름, 한 줄 소개, 세계관을 모두 작성해야 생성할 수 있어요!",
					);
					return true;
				}
			});
			return isRequired;
		}

		setRevisionFlag(revisionFlag) {
			this.revisionFlag = revisionFlag;
			if (this.revisionFlag === "Y") {
				isRevision.set(true);
			} else {
				isRevision.set(false);
			}
		}

		setGeneratedPrompt(generatedPrompt) {
			this.characterPersona = generatedPrompt;
			this.assign();
		}

		setScenePromptContextList(scenePromptContextList = []) {
			this.scenePromptContextList = [];
			for (const scenePromptContext of scenePromptContextList) {
				this.scenePromptContextList.push(
					new ScenePromtContextItem({
						...scenePromptContext,
						assignTrigger: this.assignScenePromptContext,
					}),
				);
			}
		}

		transformOptionsData(promptOptionList, promptOptionHistory) {
			let options = [];
			let secondarySampleOption = {
				name: "전체",
				subOptions: [],
			};
			this.secondaryTotalSampleOptionList =
				secondarySampleOption.subOptions;
			promptOptionList.forEach((promptOption) => {
				let primaryOption = options.find(
					(opt) => opt.id === promptOption.primaryOptionId,
				);
				// 1차 옵션 찾기
				if (!primaryOption) {
					primaryOption = {
						id: promptOption.primaryOptionId,
						name: promptOption.primaryOptionName,
						subOptions: [],
					};
					options.push(primaryOption);
				}

				// 2차 옵션 찾기
				if (promptOption.tertiaryOptionId) {
					let secondaryOption = primaryOption.subOptions.find(
						(opt) => opt.id === promptOption.tertiaryOptionId,
					);
					if (!secondaryOption) {
						secondaryOption = {
							id: promptOption.tertiaryOptionId,
							name: promptOption.tertiaryOptionName,
							description: promptOption.description,
							subOptions: [],
						};
						primaryOption.subOptions.push(secondaryOption);
					}
					// 3차 옵션 추가
					const tertiaryOption = {
						id: promptOption.secondaryOptionId,
						name: promptOption.secondaryOptionName,
						parentId: promptOption.tertiaryOptionId,
						sampleElements: promptOption.sampleElements,
					};
					secondaryOption.subOptions.push(tertiaryOption);
					secondarySampleOption.subOptions.push(tertiaryOption);
				} else {
					let secondaryOption = primaryOption.subOptions.find(
						(opt) => opt.id === promptOption.secondaryOptionId,
					);
					if (!secondaryOption) {
						secondaryOption = {
							id: promptOption.secondaryOptionId,
							name: promptOption.secondaryOptionName,
							description: promptOption.description,
							subOptions: [],
						};
						primaryOption.subOptions.push(secondaryOption);
					}
				}
			});
			options
				.find((opt) => opt.id === 2)
				.subOptions.unshift(secondarySampleOption);
			this.promptOptionList = options;
		}

		toggleBlockMode(on) {
			const chatVersion = on ? "V3" : "V2";
			PRConnect.send("/api/Chat/modifyChatVersion", { chatId, chatVersion }, (data) => {
				if (data.header.status === "success") {
					this.chatVersion = chatVersion;
					// V2로 끄면 V3 전용 탭(대화 설정·블록·응답)에서 벗어나기
					if (chatVersion !== "V3" && V3_ONLY_TABS.includes(this.currentTab))
						this.currentTab = "info";
					// 프리뷰 HTML이 새 버전으로 리빌드됐으니 iframe 리로드
					try { refIframe?.contentWindow?.location?.reload(); } catch (e) { /* iframe 미준비 */ }
				} else {
					alert("현재 플랜에서는 블록 모드를 사용할 수 없습니다.");
				}
				this.assign();
			});
		}

		changeCurrentTab(currentTab) {
			if (this.currentTab == currentTab) {
				return;
			}
			this.currentTab = currentTab;
			this.assign();
		}

		changeTitle(title) {
			if (this.title == title) {
				return;
			}
			const oldTitle = this.title;
			this.title = title;
			this.save();
			// 제목 변경 시 이 챗 문맥 폴더(챗/{제목}) 하위 자산 전체를 새 제목 폴더로 이동(프리픽스 일괄 치환).
			moveFolder(
				null,
				chatAssetFolder({ title: oldTitle, chatId: this.chatId }),
				chatAssetFolder(this),
			).catch(() => {});
		}

		changeSubtitle(subTitle) {
			if (this.subTitle == subTitle) {
				return;
			}
			this.subTitle = subTitle;
			this.save();
		}
		change(target, value) {
			if (this[target] === value) {
				return;
			}
			this[target] = value;
			this.save();
		}

		changeBackImageBlur() {
			this.backImageCss.changeBlur();
			this.save();
		}

		changeBackImageBlur() {
			this.backImageCss.changeDarkly();
			this.save();
		}

		changeProfileChatBackColor(colorObj) {
			if (this.profileChatCss.color == colorObj.toRgbString()) {
				return;
			}
			this.profileChatCss.changeColor(colorObj);
			this.save();
		}

		changeUserChatBackColor(colorObj) {
			if (this.userChatCss.color == colorObj.toRgbString()) {
				return;
			}
			this.userChatCss.changeColor(colorObj);
			this.save();
		}

		changeFixedButtonColor(colorObj) {
			if (this.fixedButtonCss.color == colorObj.toRgbString()) {
				return;
			}
			this.fixedButtonCss.changeColor(colorObj);
			this.save();
		}

		// ── V3 테마 프리셋 ──────────────────────────────────────────────
		getThemePreset() {
			return this.profileChatCss.themePreset || "custom";
		}

		isCustomTheme() {
			return this.getThemePreset() === "custom";
		}

		// '밝은 버전'/'어두운 버전'/'직접 설정'. 프리셋 이름만 저장하고 실제 색은 런타임(resolveTheme)이 결정.
		changeThemePreset(preset) {
			if (this.getThemePreset() === preset) return;
			this.profileChatCss.themePreset = preset;
			this.save();
		}

		isDarkMode() {
			return this.profileChatCss.darkMode === true;
		}

		// custom 모드 전용: 어두운 배경 토글
		toggleDarkMode() {
			this.profileChatCss.darkMode = !this.isDarkMode();
			this.save();
		}

		isUseFixedButton() {
			return this.useFixedButton === "Y";
		}

		toggleUseFixedButton() {
			this.useFixedButton = this.useFixedButton === "Y" ? "N" : "Y";
			this.save();
		}

		addFixedButton() {
			const id = Math.random().toString(36).slice(2, 11);
			this.fixedButtonList = [...this.fixedButtonList, { id, title: "", url: "" }];
			this.assign();
		}

		deleteFixedButton(id) {
			this.fixedButtonList = this.fixedButtonList.filter((b) => b.id !== id);
			this.save();
		}

		updateFixedButton(id, field, value) {
			const btn = this.fixedButtonList.find((b) => b.id === id);
			if (btn) {
				btn[field] = value;
				this.save();
			}
		}

		reorderFixedButtons(orderedIds) {
			const map = new Map(this.fixedButtonList.map((b) => [b.id, b]));
			this.fixedButtonList = orderedIds.map((id) => map.get(id)).filter(Boolean);
			this.save();
		}

		changeRandomMessageFlag() {
			this.randomMessageFlag = this.randomMessageFlag === "Y" ? "N" : "Y";
			this.save(clickConversationReset);
		}

		changeAdditionalMessageFlag() {
			this.additionalMessageFlag =
				this.additionalMessageFlag === "Y" ? "N" : "Y";
			this.save(clickConversationReset);
		}

		// 음성 채팅 토글 — 대화 내용/프롬프트와 무관(마이크·스피커 노출만 바뀜)하므로 대화 리셋 없이 저장.
		changeTtsFlag() {
			this.ttsFlag = this.ttsFlag === "Y" ? "N" : "Y";
			this.save();
		}

		changeSttFlag() {
			this.sttFlag = this.sttFlag === "Y" ? "N" : "Y";
			// 음성 입력을 끄면 음성 전용도 같이 내린다 — 남겨 두면 텍스트도 음성도 못 쓰는 챗이 된다.
			if (this.sttFlag === "N") this.sttOnly = "N";
			this.save();
		}

		changeSttOnlyEdit() {
			this.sttOnlyEdit = this.sttOnlyEdit === "Y" ? "N" : "Y";
			this.save();
		}

		changeSttOnly() {
			this.sttOnly = this.sttOnly === "Y" ? "N" : "Y";
			this.save();
		}

		// 음성 전용을 어느 구간에 걸지("all" | "step" | "free"). 스텝 판정은 런타임이 서버 step 메타로 한다.
		changeSttOnlyScope(value) {
			this.sttOnlyScope = ["all", "step", "free"].includes(value) ? value : "all";
			this.save();
		}

		// 읽어주기가 끝나면 마이크 자동 열기. 끄면 사용자가 [눌러서 말하기]를 직접 누른다(말할 권한은 그대로).
		changeVoiceHandsfree() {
			this.voiceHandsfree = this.voiceHandsfree === "N" ? "Y" : "N";
			this.save();
		}

		// 녹음 자동 종료 시간. 선택지 값(ms 문자열)을 받고, "" 는 기본값(null). 범위 보정은 서버(modifyChat)가 한다.
		changeSttStartWaitMs(value) {
			this.sttStartWaitMs = value ? Number(value) : null;
			this.save();
		}

		changeSttEndPauseMs(value) {
			this.sttEndPauseMs = value ? Number(value) : null;
			this.save();
		}

		// 읽어주기 모델 변경. 저장하면 다음 게시 채팅부터 이 제공사/모델로 음성이 생성된다.
		// (현재 빌더 UI는 모델 선택을 감추고 기본 OpenAI tts-1을 쓴다. 값 배관은 유지.)
		changeTtsModel(value) {
			this.ttsModel = value ?? "";
			this.save();
		}

		// 읽어주기 목소리 변경. 저장하면 다음 게시 채팅부터 이 목소리로 음성이 생성된다.
		changeTtsVoice(value) {
			this.ttsVoice = value ?? "";
			this.save();
		}

		// 음성 입력 인식 언어 변경. 게시된 채팅의 __CHAT_CONFIG__ 로 내려가 STT 호출 언어가 된다.
		changeSttLanguage(value) {
			this.sttLanguage = value ?? "";
			this.save();
		}

		// 음성 입력 모델 변경. 서버는 이 값 > env stt_model > whisper-1 순으로 쓴다.
		changeSttModel(value) {
			this.sttModel = value ?? "";
			this.save();
		}

		isTtsFlag() {
			return this.ttsFlag === "Y";
		}

		isSttFlag() {
			return this.sttFlag === "Y";
		}

		isSttOnly() {
			return this.sttOnly === "Y";
		}

		// 레거시 챗(값 없음)은 허용으로 본다 — 막는 쪽이 아니라 여는 쪽이 안전한 기본값이다.
		isSttOnlyEdit() {
			return this.sttOnlyEdit !== "N";
		}

		// 레거시 챗(값 없음)은 켜짐으로 본다 — 지금까지 음성 전용 챗은 다 읽어주면 마이크가 자동으로 열렸다.
		isVoiceHandsfree() {
			return this.voiceHandsfree !== "N";
		}

		changeRagStrict() {
			this.ragStrict = this.ragStrict === "Y" ? "N" : "Y";
			this.save();
		}

		isRagStrict() {
			return this.ragStrict === "Y";
		}

		changeCharacterUniverse(characterUniverse) {
			this.characterUniverse = characterUniverse;
			this.save();
		}

		changeCharacterMessage(characterMessage) {
			this.characterMessage = characterMessage;
			this.save(clickConversationReset);
		}

		changeAdditionalMessage(additionalMessage) {
			this.additionalMessage = additionalMessage;
			this.save(clickConversationReset);
		}

		// 업로드/AI 생성으로 들어온 이미지(레거시 파일명). 에셋을 쓰던 상태였다면 참조를 비워
		// 폴백이 방금 만든 이미지를 가리키게 한다(에셋 URL이 남아 있으면 그게 우선돼 안 바뀜).
		changeProfileImageContent(profileImageContent, isUseAi) {
			this.profileImageContent = profileImageContent;
			this.profileAssetId = null;
			this.profileAssetUrl = null;
			this.aiImageFlag = isUseAi === true ? "Y" : "N";
			this.save();
		}

		// 배경 AI/업로드 적용 — 프로필과 동일. (AIImagePopup 배경 적용이 이걸 호출)
		changeBackImageContent(backImageContent, isUseAi) {
			this.backImageContent = backImageContent;
			this.backAssetId = null;
			this.backAssetUrl = null;
			if (isUseAi === true) this.aiImageFlag = "Y";
			this.save();
		}

		changeCategory(category) {
			if (this.category === category) return;
			this.category = category;
			this.save();
		}

		changePrimaryOption(id) {
			if (this.primaryOption === id) {
				return false;
			}
			this.primaryOptionId = id;
			const secondaryOptionList = this.promptOptionList.find(
				(option) => option.id === this.primaryOptionId,
			).subOptions;
			let option = secondaryOptionList.find(
				(secondaryOption) =>
					secondaryOption.id === this.secondaryOptionId,
			);
			// 기존 선택된 2차 옵션이 없으면 첫번째 항목을 기본선택으로 한다.
			if (!option) {
				option = secondaryOptionList[0];
				this.secondaryOptionId = option.id;
			}
			this.savePromptOption();
			return true;
		}

		changeSecondaryOption(secondaryOption) {
			if (this.secondaryOptionId === secondaryOption.id) {
				return false;
			}
			this.secondaryOptionId = secondaryOption.id;
			if (secondaryOption.sampleElements) {
				this.characterPersona = secondaryOption.sampleElements;
			}

			this.savePromptOption();
			return true;
		}

		changeCharacterPersona(characterPersona) {
			if (this.characterPersona === characterPersona) return;
			this.characterPersona = characterPersona;
			this.savePromptOption();
		}

		isSelectedSecondarySampleOption(id) {
			let secondaryOption = this.getSecondaryOption();
			const parentId = secondaryOption?.parentId;
			let currentId = secondaryOption?.id;
			if (parentId) {
				currentId = parentId;
			}
			return currentId === id;
		}

		isSampleSecondaryOptionSelected() {
			return !!this.primaryOptionId && !!this.secondaryOptionId;
		}

		isAutoGenerateOption() {
			return this.primaryOptionId === 1;
		}

		isSampleOption() {
			return this.primaryOptionId === 2;
		}

		isBackImageBlur() {
			return this.backImageCss.isBlur();
		}

		isBackImageDarkly() {
			return this.backImageCss.isDarkly();
		}

		isRandomMessageFlag() {
			return this.randomMessageFlag === "Y";
		}

		isAdditionalMessageFlag() {
			return this.additionalMessageFlag === "Y";
		}

		isUseRag() {
			return this.useRag === "Y";
		}

		setUseRag(value) {
			this.useRag = value;
			this.assign();
		}

		setUseVectorRag(value) {
			this.useVectorRag = value;
			this.assign();
		}

		setUploadedDocs(docs) {
			this.uploadedDocs = docs;
			this.isDocLoaded = true;
			this.assign();
		}

		addUploadedDoc(doc) {
			this.uploadedDocs = [...this.uploadedDocs, doc];
			this.assign();
		}

		clearUploadedDocs() {
			this.uploadedDocs = [];
			this.isDocLoaded = false;
			this.assign();
		}

		isRevision() {
			return this.revisionFlag === "Y";
		}

		isPost() {
			return this.postFlag === "Y";
		}

		isCurrentTab(tab) {
			return this.currentTab == tab;
		}

		get(target) {
			return this[target];
		}

		// 에셋 우선 → 레거시 파일명 → 둘 다 없으면 null(카드가 빈 드롭존 표시). 로고 getter와 동일 규약.
		getProfileImageContent() {
			if (this.profileAssetId) return this.profileAssetUrl || null;
			if (!this.profileImageContent) return null;
			return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/chats/${this.chatId}/common/profile-images/${this.profileImageContent}`;
		}

		getBackImageContent() {
			if (this.backAssetId) return this.backAssetUrl || null;
			if (!this.backImageContent) return null;
			return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/chats/${this.chatId}/common/images/${this.backImageContent}`;
		}

		// 프로필/배경 에셋 선택·해제. 에셋으로 바꾸면 레거시 파일명은 비워 참조를 하나로 만든다(로고와 동일).
		changeProfileAsset(assetId, url) {
			this.profileAssetId = assetId || null;
			this.profileAssetUrl = url || null;
			this.profileImageContent = null;
			this.save();
		}

		changeBackAsset(assetId, url) {
			this.backAssetId = assetId || null;
			this.backAssetUrl = url || null;
			this.backImageContent = null;
			this.save();
		}

		// 에셋이 지정돼 있으면 그 current 버전 URL, 아니면 레거시 파일명 경로. 둘 다 없으면 null(미설정).
		getLogoImageContent() {
			if (this.logoAssetId) return this.logoAssetUrl || null;
			if (!this.logoImageContent) return null;
			return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/chats/${this.chatId}/common/logo-images/${this.logoImageContent}`;
		}

		// 로고 에셋 선택/해제. 에셋으로 바꾸면 레거시 파일명은 비워 참조를 하나로 만든다.
		changeLogoAsset(assetId, url) {
			this.logoAssetId = assetId || null;
			this.logoAssetUrl = url || null;
			this.logoImageContent = null;
			this.save();
		}

		getCharacterImageContent() {
			return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/chats/${this.chatId}/common/character-images/${this.characterImageContent}`;
		}

		getSubtitleRows() {
			return this.subTitle?.split("\n").length;
		}

		getCharacterUniverseRows() {
			return this.characterUniverse?.split("\n").length;
		}

		getCharacterPersona() {
			return this.characterPersona?.split("\n").length;
		}

		getCharacterMessageRows() {
			return this.characterMessage?.split("\n").length;
		}

		getAdditionalMessageRows() {
			return this.additionalMessage?.split("\n").length;
		}

		getSecondaryOption() {
			const primaryOption = this.promptOptionList.find(
				(option) => option.id === this.primaryOptionId,
			);
			let secondaryOption = primaryOption.subOptions.find(
				(option) => option.id === this.secondaryOptionId,
			);
			if (!secondaryOption) {
				for (const option of primaryOption.subOptions) {
					const tertiaryOption = option.subOptions?.find(
						(opt) => opt.id === this.secondaryOptionId,
					);
					if (tertiaryOption) {
						secondaryOption = tertiaryOption;
						break;
					}
				}
			}
			return secondaryOption;
		}

		getTertiaryOptionList() {
			let secondaryOption = this.getSecondaryOption();
			const parentId = secondaryOption?.parentId;

			if (parentId) {
				secondaryOption = this.promptOptionList
					.find((opt) => opt.id === this.primaryOptionId)
					.subOptions.find((opt) => opt.id === parentId);
			}

			return secondaryOption.subOptions;
		}

		getTotalTertiaryOptionList() {
			return this.secondaryTotalSampleOptionList;
		}

		getPrimaryOptionName() {
			let option = this.promptOptionList.find(
				(option) => option.id === this.primaryOptionId,
			);
			return option ? option.name : "";
		}

		getSecondaryOptionName() {
			// 1차옵션에 따른 2차 옵션 리스트
			const secondaryOptionList = this.promptOptionList.find(
				(option) => option.id === this.primaryOptionId,
			).subOptions;
			let option = secondaryOptionList.find(
				(secondaryOption) =>
					secondaryOption.id === this.secondaryOptionId,
			);
			// 기존 선택된 2차 옵션이 없으면 첫번째 항목을 기본선택으로 한다.
			if (!option) {
				option = secondaryOptionList[0];
				this.secondaryOptionId = option.id;
			}
			return option.name;
		}

		getTertiarySampleOptionName() {
			const selectedSecondaryOption = this.getSecondaryOption();
			const parentId = selectedSecondaryOption?.parentId;
			let name;
			if (parentId) {
				name = selectedSecondaryOption.name;
			} else {
				name = "샘플을 선택해 주세요.";
			}
			return name;
		}

		getSecondarySampleCategoryList() {
			return this.promptOptionList.find(
				(option) => option.id === this.primaryOptionId,
			).subOptions;
		}

		getDefaultPrimaryOptionName() {
			let option = this.promptOptionList.find(
				(option) => option.id === DEFAULT_PROMPT_PRIMARY_OPTION_ID,
			);
			this.primaryOptionId = DEFAULT_PROMPT_PRIMARY_OPTION_ID;
			this.secondaryOptionId = DEFAULT_PROMPT_SECONDARY_OPTION_ID;
			return option.name;
		}

		getPrimaryOptionList() {
			return this.promptOptionList;
		}

		getSecondaryOptionList() {
			return this.promptOptionList.find(
				(option) => option.id === this.primaryOptionId,
			).subOptions;
		}

		getRequirePromptGenerate() {
			const requiredParam = {
				chatId: this.chatId,
				name: this.title,
				description: this.subTitle,
				universe: this.characterUniverse,
				primaryOptionId: this.primaryOptionId,
				secondaryOptionId: this.secondaryOptionId,
			};
			return requiredParam;
		}

		changeBackImageBlur() {
			this.backImageCss.changeBlur();
			this.save();
		}

		changeBackImageDarkly() {
			this.backImageCss.changeDarkly();
			this.save();
		}
		activateRevisionFlag() {
			this.revisionFlag = "Y";
			isRevision.set(true);
		}
		deactivateRevisionFlag() {
			this.revisionFlag = "N";
			isRevision.set(false);
		}
		doPost() {
			// 필수값 체크. 막히면 툴팁 + 해당 탭 이동까지 하고 여기서 끝난다.
			const isRequired = this.checkRequiredFields();
			if (isRequired) {
				return;
			}
			// 게시 성공을 확인한 뒤에야 "게시됨"으로 넘어간다.
			// (예전엔 요청 전에 postFlag/revisionFlag 를 먼저 내려서, 서버가 실패해도
			//  화면상으론 게시된 것처럼 보이고 다음 클릭부터는 팝업만 뜨는 상태가 됐다)
			clickPosting({
				isPosted: this.isPost(),
				onSuccess: () => {
					this.postFlag = "Y";
					this.deactivateRevisionFlag();
					this.assign();
				},
			});
		}
		save(func) {
			const param = {
				...this,
				backImageCss: JSON.stringify(this.backImageCss),
				profileChatCss: JSON.stringify(this.profileChatCss),
				userChatCss: JSON.stringify(this.userChatCss),
				fixedButtonCss: JSON.stringify(this.fixedButtonCss),
				fixedButtonList: JSON.stringify(this.fixedButtonList),
				useFixedButton: this.useFixedButton,
				characterPersonaKeyword: JSON.stringify(
					characterPersonaRefKeywordList,
				),
				// 편집 중 빈 행·빈 지시문은 화면에만 두고 서버로는 정리해서 보낸다(learnerDecls.js)
				collectKeys: normalizeCollectKeys(this.collectKeys),
				traits: normalizeTraits(this.traits),
			};
			chat.assign();
			this.activateRevisionFlag();
			markSaving(); // 헤더 자동저장 인디케이터: 저장 중…
			PRConnect.send(
				"/api/Chat/modifyChat",
				param,
				(data) => {
					if (data.header.status === "success") {
						console.log("chat update success");
						chat.assign();
						if (func) {
							func();
						}
						refIframe.contentWindow.location.reload();
						markSaved(); // 저장됨 ✓ (잠깐 표시 후 idle)
					} else {
						markSaveIdle();
					}
				},
				() => markSaveIdle(), // 네트워크 실패 시 인디케이터 원위치
			);
		}

		savePromptOption() {
			const param = {
				chatId: this.chatId,
				primaryOptionId: this.primaryOptionId,
				secondaryOptionId: this.secondaryOptionId,
				characterPersona: this.characterPersona,
			};
			chat.assign();
			PRConnect.send(
				"/api/Chat/modifyChatPromptOptionHistory",
				param,
				(data) => {
					if (data.header.status === "success") {
						console.log("chat prompt update success");
						chat.assign();
						refIframe.contentWindow.location.reload();
					}
				},
			);
		}

		saveScenePromptContext(targetScenePromptContext) {
			// 팝업 끄고, 팝업 context 비우기
			this.assignScenePromptContext(null, false);
			this.assign();
			PRConnect.send(
				"/api/Chat/modifyScenePromptContext",
				targetScenePromptContext,
				(data) => {
					if (data.header.status === "success") {
						console.log("chat scenePromptContext update success");
						targetScenePromptContext.markAsSaved();
						this.assign();
					}
				},
			);
		}

		handleSceneImageFileUpload(e) {
			let image = e.target.files[0];
			const key = `chats/${chatId}/common/scene-images/${image.name}`;
			const type = image.type;
			const imageFileName = image.name;
			PRConnect.send(
				"/api/File/uploadPresignedUrl",
				{ key, type },
				(data) => {
					axios
						.put(data.result, image, {
							headers: { "Content-Type": type },
						})
						.then((response) => {
							if (scenePromptContext) {
								scenePromptContext.changeSceneImage(
									imageFileName,
								);
								return;
							}
							this.addSceneImage(imageFileName);
						});
				},
			);
		}

		handleAIImagePopup(type) {
			isAIImagePopup = true;
			imageType = type;
		}

		// 블록 카드용: 파일 업로드 → 씬 이미지 라이브러리에 추가(팝업 없이) → onUrl(url) 콜백
		addSceneImageFromFile(file, onUrl) {
			const name = file.name;
			const key = `chats/${chatId}/common/scene-images/${name}`;
			PRConnect.send("/api/File/uploadPresignedUrl", { key, type: file.type }, (data) => {
				axios
					.put(data.result, file, { headers: { "Content-Type": file.type } })
					.then(() => {
						PRConnect.send("/api/Chat/createScenePromptContext", { name, chatId }, (res) => {
							if (res.header.status !== "success") return;
							const item = new ScenePromtContextItem({
								id: res.result,
								chatId,
								name,
								assignTrigger: this.assignScenePromptContext,
							});
							this.scenePromptContextList.push(item);
							this.assign();
							if (onUrl) onUrl(item.getImageUrl());
						});
					});
			});
		}

		addSceneImage(name) {
			PRConnect.send(
				"/api/Chat/createScenePromptContext",
				{ name, chatId },
				(data) => {
					if (data.header.status === "success") {
						const id = data.result;
						const scenePromptContextItem =
							new ScenePromtContextItem({
								id,
								chatId,
								name,
								assignTrigger: this.assignScenePromptContext,
							});
						this.scenePromptContextList.push(
							scenePromptContextItem,
						);
						this.assignScenePromptContext(scenePromptContextItem);
					}
				},
			);
		}

		addScenePromptContext() {
			this.scenePromptContextList.push(new ScenePromtContextItem({}));
		}

		assign() {
			chat = chat;
		}

		// 하위 화면(BlockContext 레슨 카드)의 [프리뷰에서 이 레슨부터] — [대화 리셋]과 같은 정리 경로(resetPreview)를 탄다.
		previewFrom(startBlockId) {
			resetPreview(startBlockId || null);
		}

		// 팝업에 쓰이는 context 세팅 및 렌더링 유도
		assignScenePromptContext(targetScenePromptContext, popupFlag = true) {
			scenePromptContext = targetScenePromptContext;
			isSceneImageAIPopup = popupFlag;
		}

		assignAIImageList() {
			isAIImagePopup = false;
		}

		isUsable() {
			return true;
		}

		deleteScenePromptContext(id) {
			const originList = [...this.scenePromptContextList];
			this.scenePromptContextList = this.scenePromptContextList.filter(
				(scenePromptContext) => scenePromptContext.id !== id,
			);
			// chat에 담겨있으니까 재할당해서 리렌더링 되도록 유도
			this.assign();
			PRConnect.send(
				"/api/Chat/deleteScenePromptContext",
				{ id },
				(data) => {
					if (data.header.status === "success") {
						console.log("deleteScenePromptContext success");
					}
				},
				(error) => {
					console.error("deleteScenePromptContext failed");
					this.scenePromptContextList = originList;
					this.assign();
				},
			);
		}
	}

	class BackImageCss {
		constructor({ blur = "N", darkly = "N" }) {
			this.blur = blur;
			this.darkly = darkly;
		}
		changeBlur() {
			this.blur = this.blur === "Y" ? "N" : "Y";
		}
		changeDarkly() {
			this.darkly = this.darkly === "Y" ? "N" : "Y";
		}
		isBlur() {
			return this.blur === "Y";
		}
		isDarkly() {
			return this.darkly === "Y";
		}
	}

	class ChatCss {
		constructor({ color = "#FFFFFF", fontColor, showProfileImage, showTitle, progressFormat, darkMode, themePreset }) {
			this.color = color == null ? "#FFFFFF" : color;
			this.fontColor = fontColor;
			// V3: 프로필 이미지 표시 여부(빌더 토글). 미설정이면 보존만, 기본 동작은 true.
			if (showProfileImage !== undefined) this.showProfileImage = showProfileImage;
			// V3: 헤더 제목(챗 이름) 표시 여부. 로고와 독립 — 로고 옆에 제목을 같이 둘 수도, 로고만 둘 수도 있다.
			// 미설정이면 보존만, 기본 동작은 true(기존 챗은 제목이 계속 보임).
			if (showTitle !== undefined) this.showTitle = showTitle;
			// V3 진행도 숫자 표기: 'count'(3/5) | 'percent'(60%) | 'both'. 진행바와 진행도 패널이 함께 쓴다.
			// ⚠️ 여기 안 적으면 JSON에 있어도 이 생성자가 버린다(알려진 필드만 복사) → 저장할 때마다 설정이 날아간다.
			if (progressFormat !== undefined) this.progressFormat = progressFormat;
			// V3 테마 백: profileChatCss에서 서버 buildV3Html가 읽음.
			//  - themePreset: 'light'|'dark' → 런타임이 색/다크모드 결정. 'custom'(기본) → 아래 색 필드 사용.
			//  - darkMode: custom 모드에서 어두운 배경 여부.
			if (darkMode !== undefined) this.darkMode = darkMode;
			if (themePreset !== undefined) this.themePreset = themePreset;
		}

		changeColor(colorObj) {
			this.color = colorObj.toRgbString();
			console.log("color: ", this.color);
			console.log("luminance1: ", colorObj.getLuminance());
			const luminace =
				colorObj.r * 0.299 + 0.587 * colorObj.g + 0.114 * colorObj.b;
			console.log("luminance2: ", luminace);
			//this.fontColor = colorObj.getLuminance() > 128 ? 'black' : 'white';
			this.fontColor = luminace > 200 ? "black" : "white";
		}
	}

	class ScenePromtContextItem {
		constructor({
			id,
			chatId,
			title = "",
			prompt = "",
			name,
			assignTrigger,
		}) {
			this.id = id;
			this.chatId = chatId;
			this.title = title;
			this.prompt = prompt;
			this.name = name;
			this.sceneAIImageList = sceneAIImageList ? sceneAIImageList : [];
			this.assign = assignTrigger;
			this.isNewFlag = this.prompt && this.title ? false : true;
		}

		getImageUrl() {
			return `https://groovworks-avatalk-public-file-storage.s3.ap-northeast-2.amazonaws.com/chats/${this.chatId}/common/scene-images/${this.name}`;
		}

		changeTitle(title) {
			if (this.title == title) return;
			this.title = title;
		}

		changePrompt(prompt) {
			if (this.prompt == prompt) return;
			this.prompt = prompt;
		}

		changeSceneImage(name) {
			if (this.name == name) return;
			this.name = name;
			this.save();
		}

		markAsSaved() {
			this.isNewFlag = false;
		}

		save() {
			PRConnect.send(
				"/api/Chat/modifyScenePromptContext",
				this,
				(data) => {
					if (data.header.status === "success") {
						console.log("ScenePromtContextItem update success");
					}
				},
			);
			this.assign(this);
			chat.assign();
		}
	}

	const clickReferenceBackgImageUpload = () => {
		addRefenceBackImageRef.click();
	};

	const deleteChatIdFromLocalStorage = (key, chatId) => {
		let chatTokenList = [];

		try {
			chatTokenList = JSON.parse(localStorage.getItem(key) || "[]");
		} catch {
			chatTokenList = [];
		}
		const filterdTokenList = chatTokenList.filter(
			(chat) => chat.id !== chatId,
		);
		try {
			localStorage.setItem(
				"chatTokens",
				JSON.stringify(filterdTokenList),
			);
		} catch (e) {
			console.error("chatTokens 저장 실패:", e);
		}
	};

	const createCookieForPubImageList = (cookieName, chatIdToCreate) => {
		const cookies = getCookies();
		const cookieValue = cookies[cookieName];
	};

	// 프리뷰 정리 = [대화 리셋]과 [프리뷰에서 이 레슨부터]가 함께 쓰는 **한 경로**.
	//   지우는 것: 대화 토큰(→ 새 대화·새 세션 상태) + 서버의 이 챗 진행도·수집 정보·챗 울타리 학습자 정보/측정 이력
	//              (module/Chat.js resetLearnerProgress). 그다음 iframe 을 다시 띄운다.
	//   남기는 것: 프리뷰 학습자 키(다른 챗 프리뷰 진행도가 걸려 있다) · 가상 학습자 선택(저작 설정이지 진도가 아니다).
	//   startBlockId 를 주면 새 대화를 엔트리 대신 그 블록에서 시작한다 — 런타임이 첫 init 에 싣고 지우는 일회성 표시
	//   (sessionStorage v3_preview_start:{chatId}, CHAT lib/previewStart.ts). 정리를 건너뛰고 바로 뛰어들게 하지 않는다:
	//   같은 대화에서 이미 해 본 레슨으로 들어가면 엔진이 '복귀'로 보고 여는 말 없이 이어 가고(NavigateHandler.tryResume),
	//   레슨마다 반쯤 남은 진도가 쌓여 새로고침 재개가 엉뚱한 레슨으로 간다.
	const resetPreview = (startBlockId = null) => {
		// 좁은 화면에서 프리뷰가 닫혀 있으면 열어 준다(응답 탭이면 프리뷰 탭으로)
		previewOpen = true;
		previewPanelTab = "preview";
		try {
			if (startBlockId) sessionStorage.setItem(`v3_preview_start:${chatId}`, startBlockId);
			else sessionStorage.removeItem(`v3_preview_start:${chatId}`); // 지난 바로가기 표시가 남아 있으면 지운다
		} catch (e) {
			/* 저장소 차단 — 엔트리부터 시작한다 */
		}
		// 챗 버전에 따라 iframe에 로드되는 런타임이 달라 토큰 저장 위치도 다르므로 분기한다.
		//   V3    → React 런타임(CHAT/src/features/chat/useChat.ts): localStorage "v3_chat_token:{chatId}:{env}"
		//   V1/V2 → 레거시 iframe 템플릿(chat_1.x.js):              localStorage "chatTokens" 배열
		if (chat?.chatVersion === "V3") {
			try {
				// 빌더 프리뷰 iframe은 항상 preview 엔드포인트라 런타임이 ':preview' 키에 저장한다.
				// (env 스코프 도입 전 키도 같이 지워 옛 잔재를 정리 — 안 지우면 리셋해도 토큰이 남아 무효)
				localStorage.removeItem(`v3_chat_token:${chatId}:preview`);
				localStorage.removeItem(`v3_chat_token:${chatId}`);
				// ⑨ 리셋 = "처음부터 다시" → 학습 진행도도 함께 초기화한다.
				//   ⚠️ learnerKey는 "사람" 축이라 chatId로 나누지 않는다(카테고리 채팅이 같은 학습자를 공유해야 하므로).
				//      그래서 이 키를 지우면 새 학습자가 되어 **다른 챗 프리뷰 진행도까지** 날아간다.
				//      → 키는 그대로 두고, 서버에 "이 챗 진행도만 삭제"를 요청한다(고아 행도 안 남는다).
				//   프리뷰 iframe은 같은 origin이라 런타임이 저장한 키를 여기서 그대로 읽을 수 있다.
				const learnerKey =
					localStorage.getItem(`v3_learner:preview`) ||
					localStorage.getItem(`v3_learner:${chatId}:preview`) ||
					localStorage.getItem(`v3_learner:${chatId}`);
				localStorage.removeItem(`v3_learner:${chatId}:preview`); // 구 키(채팅별) 잔재 정리
				localStorage.removeItem(`v3_learner:${chatId}`);
				if (learnerKey) {
					// ⚠️ 삭제가 끝난 뒤에 리로드한다. 먼저 리로드하면 런타임 init이 아직 안 지워진
					//    진행도를 읽어 레슨 중간부터 재개해 버린다(리셋이 무효로 보인다).
					PRConnect.send("/api/Chat/resetLearnerProgress", { chatId, learnerKey }, () =>
						refIframe.contentWindow.location.reload(),
					);
					return;
				}
			} catch (e) {
				console.error("v3_chat_token 삭제 실패:", e);
			}
		} else {
			deleteChatIdFromLocalStorage("chatTokens", chatId);
		}
		refIframe.contentWindow.location.reload();
	};
	const clickConversationReset = () => resetPreview(null);

	const clickIframeRefresh = () => {
		refIframe.contentWindow.location.reload();
	};

	const handleTextareaNextbreak = (e, target) => {
		const currentContext = e.target.value;
		const originContext = chat.get(target);
		const currentRows = currentContext.split("\n").length;
		const originRows = originContext.split("\n").length;
		if (originRows != currentRows) {
			if (target === "characterPersona") {
				chat.changeCharacterPersona(currentContext);
			} else {
				chat.change(target, currentContext);
			}
		}
	};

	// 프리뷰 '테스트 모드': 켜면 iframe(CHAT 런타임)이 각 봇 답변 밑에 "어느 블록이 나왔는지" 배지를 표시.
	let previewTestMode = false;
	const postTestMode = () => {
		try {
			refIframe?.contentWindow?.postMessage(
				{ type: "AVATALK_TEST_MODE", on: previewTestMode },
				window.location.origin,
			);
		} catch (e) {
			/* iframe 미준비 */
		}
	};
	const toggleTestMode = () => {
		previewTestMode = !previewTestMode;
		postTestMode();
	};

	// 프리뷰 '가상 학습자'(V3): 저작자가 학습자 정보 값·닉네임을 골라 그 학습자로 대화를 본다.
	//   지침의 {{변수}}·학습자별 내용·레벨 말투(guide)가 이 값으로 바뀐다(서버 RunChat — 프리뷰 환경에서만 반영).
	//   ⚠️ 값의 주인은 sessionStorage(`v3_preview_learner:{chatId}`) — 프리뷰 iframe 이 같은 origin 이라
	//      빌더와 같은 저장소를 본다. iframe 리로드 직후 첫 요청(init)이 postMessage 보다 먼저 나가도
	//      런타임이 저장소에서 읽어 같은 학습자로 시작한다(CHAT lib/previewLearner.ts).
	//   빈 값 = "값 없음" → 선언의 기본값이 쓰인다(로그인 전·사전 테스트 전 학습자와 같은 상태).
	let previewLearner = { traits: {}, nickname: "" };
	let learnerPanelOpen = false;
	const previewLearnerKey = () => `v3_preview_learner:${chatId}`;
	const isLearnerSet = (l) => !!(l?.nickname || Object.values(l?.traits || {}).some((v) => v));
	// 고를 수 있는 항목 = 닉네임을 뺀 사전 설정 항목. 값 후보는 지시문(guide.map)에 적힌 값들.
	const learnerDeclsOf = (c) => (c?.traits || []).filter((t) => t?.key && t.key !== "nickname");
	// 사전 테스트에 연결된 항목은 테스트 구간(values)이 레벨 목록이다(지시문을 비운 레벨도 포함) — BlockContext.knownValues 와 같은 규칙
	const learnerValuesOf = (t) =>
		(Array.isArray(t?.values) && t.values.length ? t.values : Object.keys(t?.guide?.map || {})).filter((v) => String(v).trim());
	const learnerDefaultOf = (c, key) => (c?.traits || []).find((t) => t?.key === key)?.default || "";
	const loadPreviewLearner = () => {
		try {
			const raw = sessionStorage.getItem(previewLearnerKey());
			const v = raw ? JSON.parse(raw) : null;
			previewLearner = { traits: { ...(v?.traits || {}) }, nickname: v?.nickname || "" };
		} catch (e) {
			previewLearner = { traits: {}, nickname: "" };
		}
	};
	const postPreviewLearner = () => {
		const learner = isLearnerSet(previewLearner) ? previewLearner : null;
		try {
			if (learner) sessionStorage.setItem(previewLearnerKey(), JSON.stringify(learner));
			else sessionStorage.removeItem(previewLearnerKey());
		} catch (e) {
			/* 저장소 차단 — postMessage 로만 전달 */
		}
		try {
			refIframe?.contentWindow?.postMessage({ type: "AVATALK_PREVIEW_LEARNER", learner }, window.location.origin);
		} catch (e) {
			/* iframe 미준비 */
		}
	};
	const setPreviewTrait = (key, value) => {
		previewLearner = { ...previewLearner, traits: { ...previewLearner.traits, [key]: value } };
		postPreviewLearner();
	};
	const setPreviewNickname = (value) => {
		previewLearner = { ...previewLearner, nickname: value.trim().slice(0, 20) };
		postPreviewLearner();
	};
	const clearPreviewLearner = () => {
		previewLearner = { traits: {}, nickname: "" };
		postPreviewLearner();
	};
	$: if (chatId) loadPreviewLearner();
	// 버튼에 지금 학습자를 짧게 — 값이 없으면 기본값으로 대화한다는 걸 드러낸다.
	$: learnerSummary = isLearnerSet(previewLearner)
		? [previewLearner.nickname, ...Object.values(previewLearner.traits).filter(Boolean)].filter(Boolean).join(" · ")
		: "기본값";

	// 반응형: 좁은 화면에선 프리뷰를 사이드가 아니라 오버레이 드로어로. 브레이크포인트를 넘나들 때 기본 상태 조정.
	onMount(() => {
		const mql = window.matchMedia("(max-width: 1023px)"); // Tailwind lg(≥1024)와 경계 일치
		const apply = () => {
			isNarrow = mql.matches;
			previewOpen = !mql.matches; // 넓으면 항상 표시, 좁으면 기본 닫힘
		};
		apply();
		mql.addEventListener("change", apply);
		return () => mql.removeEventListener("change", apply);
	});

	const loadIframe = () => {
		// iframe 로드 완료 시점엔 refIframe이 확실히 바인딩됨 → 프리뷰 postMessage용 스토어 최신화.
		// (onMount의 set은 isCreepong 미설정 상태라 iframe 렌더 전이어서 undefined가 담기던 문제 보완)
		iframeRefStore.set(refIframe);
		// 리로드(새로고침/리셋) 후에도 테스트 모드가 유지되게 재전송(React 리스너 마운트 여유로 약간 지연).
		if (previewTestMode) setTimeout(postTestMode, 150);
		if (chat?.chatVersion === "V3") setTimeout(postPreviewLearner, 150);
		if (!isCreepong) return;
		const message = {
			creepongId: planStore.getCreepongId(),
			origin: "avatalk",
		};
		refIframe.contentWindow.postMessage(
			message,
			`${window.location.origin}/static/avatalk/chats/${chatId}/common/index.html`,
		);
	};

	const clickCreateCharacter = () => {
		chat.doPost();
	};
</script>

<svelte:head>
	<script
		src="https://cdn.jsdelivr.net/npm/toolcool-color-picker/dist/toolcool-color-picker.min.js"
	></script>
</svelte:head>
{#if chat}
	<div class="builder-shell" class:creepong={planStore.isCreepong()}>
		<div class="tw-mx-auto tw-flex tw-h-full tw-w-full tw-overflow-hidden tw-bg-background tw-font-sans tw-text-foreground" style="max-width: var(--app-max-w, 1920px)">
			<BuilderSidebar {chat} {tabList} />

			<!-- 나머지 영역: 에디터+프리뷰를 가운데로 모으고 양옆 여백 -->
			<div class="tw-flex tw-min-w-0 tw-flex-1 tw-justify-center tw-overflow-hidden tw-bg-background">
				<div class="tw-flex tw-w-full tw-min-w-0">
					<!-- 에디터: 메인 작업영역 -->
					<main class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-overflow-hidden">
						<!-- 폰(<768px): 좌측 사이드바 대신 상단 가로 탭 -->
						<BuilderTopTabs {chat} {tabList} />
						<div class="tw-flex-1 tw-overflow-y-auto">
							<!-- 스티키 액션 툴바: 스크롤/모바일에서도 에디터 상단에 고정 → 게시·저장 상태가 항상 보인다.
							     (예전엔 스크롤 영역 안에 있어 내리면 사라졌음) -->
							<div class="tw-sticky tw-top-0 tw-z-20 tw-border-b tw-border-border tw-bg-background/90 tw-backdrop-blur">
								<div class="tw-mx-auto tw-flex tw-w-full tw-max-w-[860px] tw-items-center tw-justify-between tw-gap-3 tw-px-6 tw-py-2.5">
									<div class="tw-min-w-0">
										<div class="tw-hidden tw-truncate tw-text-[11px] tw-font-medium tw-uppercase tw-tracking-wide tw-text-muted-foreground sm:tw-block">{chat.title || "AI챗"} · 캐릭터 빌더</div>
										<h1 class="tw-truncate tw-text-base tw-font-semibold tw-text-foreground sm:tw-text-lg">{currentTabLabel}</h1>
									</div>
									<div class="tw-relative tw-flex tw-shrink-0 tw-items-center tw-gap-2 sm:tw-gap-3">
										<!-- 자동 저장 상태(shadcn Badge 스타일 pill). 저장은 필드 변경마다 자동 → 버튼 대신 상태만.
										     투명 배경 대신 은은한 배경·테두리로 형태를 잡고 상태별로 색만 부드럽게 전환. 색은 pill이 정하고 아이콘/텍스트는 상속. -->
										<div
											class="save-indicator tw-inline-flex tw-select-none tw-items-center tw-gap-1.5 tw-rounded-full tw-border tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-transition-colors {$saveStatus ===
											'saving'
												? 'tw-border-border tw-bg-muted tw-text-muted-foreground'
												: $saveStatus === 'saved'
													? 'tw-border-emerald-500/30 tw-bg-emerald-500/10 tw-text-emerald-600 dark:tw-text-emerald-400'
													: 'tw-border-transparent tw-bg-muted/50 tw-text-muted-foreground/70'}"
											aria-live="polite"
										>
											{#if $saveStatus === "saving"}
												<svg class="save-spinner tw-h-3.5 tw-w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M21 12a9 9 0 1 1-6.219-8.56" /></svg>
												<span>저장 중…</span>
											{:else if $saveStatus === "saved"}
												<svg class="save-check tw-h-3.5 tw-w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
												<span>저장됨</span>
											{:else}
												<svg class="tw-h-3.5 tw-w-3.5 tw-opacity-70" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5" /></svg>
												<span>저장됨</span>
											{/if}
										</div>
										<!-- 게시 버튼. 한 번도 게시 안 한 챗이면 "AI챗 생성", 이미 게시된 챗이면 "게시하기"(=변경분 반영).
										     어느 쪽이든 게시 설정 팝업(주소/QR/공개여부)까지 이어진다.
										     게시된 챗에 미반영 변경이 있으면 점(pulse)으로 알린다. 없으면 라벨만. -->
										<button
											type="button"
											class="tw-inline-flex tw-h-9 tw-cursor-pointer tw-items-center tw-justify-center tw-gap-1.5 tw-rounded-md tw-bg-primary tw-px-4 tw-text-sm tw-font-medium tw-text-primary-foreground tw-transition-colors hover:tw-bg-primary/90"
											on:click|stopPropagation={clickCreateCharacter}
										>
											{#if chat.isPost() && $isRevision}
												<span class="publish-dot tw-h-2 tw-w-2 tw-rounded-full tw-bg-primary-foreground" title="게시되지 않은 변경사항이 있어요"></span>
											{/if}
											{chat.isPost() ? "게시하기" : "AI챗 생성"}
										</button>
										{#if isTooltipShow}
											<div
												role="alert"
												class="tw-absolute tw-right-0 tw-top-full tw-z-50 tw-mt-2 tw-max-w-[320px] tw-rounded-md tw-bg-foreground tw-px-3 tw-py-2 tw-text-xs tw-font-medium tw-leading-relaxed tw-text-background tw-shadow-lg"
											>{tooltipContext}</div>
										{/if}
									</div>
								</div>
							</div>
							<div class="tw-mx-auto tw-w-full tw-max-w-[860px] tw-px-6 tw-pb-6 tw-pt-5">
								<div class="tw-space-y-4">
									<ProfileContext {chat} {handleTextareaNextbreak} {onImageFileUpload} />
									<DetailContext {chat} {handleTextareaNextbreak} />
									<ScenePromptContextList {chat} />
									<ConversationSettingsContext {chat} />
									<BlockContext {chat} />
									<PublishContext {chat} {handleTextareaNextbreak} {onImageFileUpload} />
									<FormSubmissionsContext {chat} />
								</div>
							</div>
						</div>
					</main>

					<!-- 좁은 화면: 프리뷰 닫혀 있을 때 떠 있는 열기 버튼 -->
					{#if isNarrow && !previewOpen}
						<button
							type="button"
							class="tw-fixed tw-bottom-5 tw-right-5 tw-z-[998] tw-inline-flex tw-h-11 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-full tw-bg-primary tw-px-4 tw-text-sm tw-font-medium tw-text-primary-foreground tw-shadow-lg tw-transition-colors hover:tw-bg-primary/90"
							on:click={() => (previewOpen = true)}
							title="미리보기 열기"
						>🔎 미리보기</button>
					{/if}

					<!-- 좁은 화면 드로어 배경(탭하면 닫힘) -->
					{#if isNarrow && previewOpen}
						<button
							type="button"
							class="tw-fixed tw-inset-0 tw-z-[999] tw-cursor-default tw-bg-black/40"
							on:click={() => (previewOpen = false)}
							aria-label="미리보기 닫기"
						></button>
					{/if}

					<!-- 미리보기: 넓은 화면=사이드 / 좁은 화면(≤1024px)=오른쪽 슬라이드 드로어 -->
					<aside
						class="tw-flex tw-flex-col tw-bg-background {isNarrow
							? 'tw-fixed tw-inset-y-0 tw-right-0 tw-z-[1000] tw-w-[min(440px,100vw)] tw-border-l tw-border-border tw-shadow-2xl tw-transition-transform ' +
								(previewOpen ? 'tw-translate-x-0' : 'tw-translate-x-full')
							: 'tw-w-[460px] tw-shrink-0 tw-border-l tw-border-border'}"
						aria-hidden={isNarrow && !previewOpen}
					>
						<!-- 프리뷰를 shadcn 카드로 감싼다: 에디터 Section 카드와 같은 언어(Builder 프리뷰와 동일).
						     공유 캔버스(bg-background) 위에 카드가 떠 있는 구조 → 동떨어짐 제거. -->
						<div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-p-4">
						<div class="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col tw-overflow-hidden tw-rounded-xl tw-border tw-border-border tw-bg-card tw-shadow-sm">
						<!-- 행 1(제목): 빌더 헤더 높이. "미리보기" + (좁은 화면) 닫기 -->
						<header class="tw-flex tw-min-h-[52px] tw-shrink-0 tw-items-center tw-justify-between tw-gap-2 tw-border-b tw-border-border tw-px-4">
							{#if canShowResponses}
								<Tabs
									items={[
										{ key: "preview", label: "미리보기" },
										{ key: "responses", label: "응답" },
									]}
									active={previewPanelTab}
									on:change={(e) => (previewPanelTab = e.detail)}
								/>
							{:else}
								<h2 class="tw-truncate tw-text-lg tw-font-semibold tw-text-foreground">미리보기</h2>
							{/if}
							{#if isNarrow}
								<button
									type="button"
									class="tw-inline-flex tw-h-8 tw-w-8 tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-md tw-text-muted-foreground tw-transition-colors hover:tw-bg-muted hover:tw-text-foreground"
									on:click={() => (previewOpen = false)}
									aria-label="미리보기 닫기"
									title="미리보기 닫기"
								>
									<svg class="tw-h-4 tw-w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
								</button>
							{/if}
						</header>

						{#if !showResponses}
						<!-- 행 2(컨트롤, 얇게): 적합성 보기 · 새로고침 · 대화 리셋 -->
						<div class="tw-flex tw-shrink-0 tw-items-center tw-justify-between tw-gap-2 tw-border-b tw-border-border tw-px-4 tw-py-2">
							<!-- 상태 토글: 켜짐=primary 채움 / 꺼짐=muted 칩. 답변마다 라우팅 배지 표시 여부 -->
							<button
								type="button"
								class="tw-inline-flex tw-h-7 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-full tw-px-3 tw-text-xs tw-font-medium tw-transition-colors {previewTestMode
									? 'tw-bg-primary tw-text-primary-foreground'
									: 'tw-bg-muted tw-text-muted-foreground hover:tw-text-foreground'}"
								on:click={toggleTestMode}
								aria-pressed={previewTestMode}
								title="켜면 답변마다 어떤 블록이 얼마나 잘 맞아 나왔는지 표시돼요"
							>
								<svg class="tw-h-3.5 tw-w-3.5 tw-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.5" /></svg>
								적합성 보기
							</button>

							{#if chat?.chatVersion === "V3"}
								<!-- 가상 학습자: 이 학습자로 대화를 본다({{변수}}·학습자별 내용·레벨 말투가 바뀜) -->
								<div class="tw-relative tw-mr-auto tw-min-w-0">
									<button
										type="button"
										class="tw-inline-flex tw-h-7 tw-max-w-[11rem] tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-full tw-px-3 tw-text-xs tw-font-medium tw-transition-colors {isLearnerSet(previewLearner)
											? 'tw-bg-primary/10 tw-text-primary'
											: 'tw-bg-muted tw-text-muted-foreground hover:tw-text-foreground'}"
										on:click={() => (learnerPanelOpen = !learnerPanelOpen)}
										aria-expanded={learnerPanelOpen}
										title="어떤 학습자로 대화해 볼지 골라요 — 지침의 {'{{변수}}'}와 학습자별 내용이 이 값으로 바뀝니다"
									>
										<svg class="tw-h-3.5 tw-w-3.5 tw-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>
										<span class="tw-truncate">학습자: {learnerSummary}</span>
									</button>
									{#if learnerPanelOpen}
										<div class="tw-absolute tw-left-0 tw-top-9 tw-z-20 tw-w-64 tw-max-w-[80vw] tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-background tw-p-3 tw-shadow-lg">
											<div class="tw-mb-2 tw-text-xs tw-text-muted-foreground">
												다음 답변부터 이 학습자로 대화해요. 처음부터 보려면 <b>대화 리셋</b>.
											</div>
											<label class="tw-mb-2 tw-block tw-text-xs">
												<span class="tw-mb-1 tw-block tw-font-medium">닉네임</span>
												<input
													class="tw-h-8 tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-border tw-bg-background tw-px-2 tw-text-xs"
													type="text"
													maxlength="20"
													value={previewLearner.nickname}
													placeholder={learnerDefaultOf(chat, "nickname") ? `비우면 기본값: ${learnerDefaultOf(chat, "nickname")}` : "비우면 닉네임 없음"}
													on:change={(e) => setPreviewNickname(e.currentTarget.value)}
												/>
											</label>
											{#each learnerDeclsOf(chat, learnerPanelOpen) as t (t.key)}
												<label class="tw-mb-2 tw-block tw-text-xs">
													<span class="tw-mb-1 tw-block tw-font-medium">{t.desc || t.key} <span class="tw-font-normal tw-text-muted-foreground">({t.key})</span></span>
													{#if learnerValuesOf(t).length}
														<select
															class="tw-h-8 tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-border tw-bg-background tw-px-2 tw-text-xs"
															value={previewLearner.traits[t.key] || ""}
															on:change={(e) => setPreviewTrait(t.key, e.currentTarget.value)}
														>
															<option value="">값 없음{t.default ? ` → 기본값 ${t.default}` : ""}</option>
															{#each learnerValuesOf(t) as v}<option value={v}>{v}</option>{/each}
														</select>
													{:else}
														<input
															class="tw-h-8 tw-w-full tw-rounded-md tw-border tw-border-solid tw-border-border tw-bg-background tw-px-2 tw-text-xs"
															type="text"
															value={previewLearner.traits[t.key] || ""}
															placeholder={t.default ? `비우면 기본값: ${t.default}` : "값 없음"}
															on:change={(e) => setPreviewTrait(t.key, e.currentTarget.value.trim())}
														/>
													{/if}
												</label>
											{:else}
												<div class="tw-mb-2 tw-text-xs tw-text-muted-foreground">학습자 정보(사전 설정) 항목이 없어요 — 콘텐츠 탭에서 추가할 수 있어요.</div>
											{/each}
											<div class="tw-flex tw-justify-between tw-gap-2">
												<button type="button" class="tw-h-7 tw-cursor-pointer tw-rounded-md tw-bg-muted tw-px-2.5 tw-text-xs tw-text-muted-foreground hover:tw-text-foreground" on:click={clearPreviewLearner}>기본값으로</button>
												<button type="button" class="tw-h-7 tw-cursor-pointer tw-rounded-md tw-bg-primary tw-px-2.5 tw-text-xs tw-text-primary-foreground" on:click={() => (learnerPanelOpen = false)}>닫기</button>
											</div>
										</div>
									{/if}
								</div>
							{/if}

							<!-- 프리뷰 액션(우측 그룹): 새로고침(무해) / 대화 리셋(대화기록 삭제 → hover destructive) -->
							<div class="tw-flex tw-items-center tw-gap-1">

							<button
								type="button"
								class="tw-inline-flex tw-h-7 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-md tw-bg-muted tw-px-2.5 tw-text-xs tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-text-foreground"
								on:click={clickIframeRefresh}
								title="미리보기 화면을 다시 불러와요"
							>
								<svg class="tw-h-3.5 tw-w-3.5 tw-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" /><path d="M8 16H3v5" /></svg>
								새로고침
							</button>
							<button
								type="button"
								class="tw-inline-flex tw-h-7 tw-cursor-pointer tw-items-center tw-gap-1.5 tw-rounded-md tw-bg-muted tw-px-2.5 tw-text-xs tw-font-medium tw-text-muted-foreground tw-transition-colors hover:tw-bg-destructive/10 hover:tw-text-destructive"
								on:click={clickConversationReset}
								title="대화 기록을 지우고 처음부터 다시 시작해요"
							>
								<svg class="tw-h-3.5 tw-w-3.5 tw-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21" /><path d="M22 21H7" /><path d="m5 11 9 9" /></svg>
								대화 리셋
							</button>
							</div>
						</div>
						{/if}

						<div class="tw-flex tw-min-h-0 tw-flex-1 tw-items-start tw-justify-center tw-overflow-auto tw-px-4 tw-py-5">
							<div class="preview-interface {showResponses ? 'tw-hidden' : ''}">
								<div class="interface-wrap">
									{#if isCreepong !== undefined}
										<iframe
											class="mobile-frame"
											bind:this={refIframe}
											src="/static/avatalk/chats/{chatId}/common/index.html?preview={isCreepong}"
											on:load={loadIframe}
										/>
									{/if}
								</div>
							</div>
							{#if showResponses}
								<BlockResponsesPanel {chat} blockId={chat.responsesBlockId} label={chat.responsesBlockLabel} />
							{/if}
						</div>
						</div>
						</div>
					</aside>
				</div>
			</div>
		</div>
	</div>
{/if}
{#if isAIImagePopup}
	<AIImagePopup
		{chat}
		isShow={isAIImagePopup}
		{aiImageLists}
		{imageType}
		{imageRefSources}
	/>
{/if}
{#if scenePromptContext}
	<ScenePromptEditPopup
		isShow={isSceneImageAIPopup}
		{scenePromptContext}
		{chat}
	/>
{/if}
<div class="image-choice-popup">
	<div class="popup-layer loading">
		<div class="bring-image">
			<div class="image-upload">
				<img
					src="/static/images/upload-icon-big.svg"
					loading="lazy"
					alt=""
					class="image-151"
				/>
				<div>
					<a href="#" class="image-upload-button w-button"
						>캐릭터 이미지 파일 가져오기
					</a>
				</div>
			</div>
			<div class="text-block-108">
				최대 크기 : 8MB, 권장사이즈 : 1000px*1000px
			</div>
		</div>
	</div>
</div>
<div class="image-choice-popup2">
	<div class="image-popup-layer">
		<img
			src="/static/images/crop-image.png"
			loading="lazy"
			sizes="100vw"
			srcset="/static/images/crop-image-p-500.png 500w, images/crop-image.png 600w"
			alt=""
			class="image-3"
		/>
		<div class="popup-button2">
			<a href="#" class="image-check-btn w-button">이미지 사용하기</a>
			<a href="#" class="image-reselection-btn w-button">다시 선택하기</a>
			<a href="#" class="image-scale-btn w-button">크기 조정하기</a>
		</div>
		<div class="x-button"></div>
	</div>
</div>

<LoadingPopup />

<!-- 요금제 팝업: Pro 전용 기능을 만졌을 때 planStore.setAuthSelectFlag(true)로 표시됨 -->
<Plan />

<style>
	:root {
		/* (선택) 다른 용도로도 쓰고 싶으면 변수로 선언해도 좋습니다 */
		--safe-bottom: env(safe-area-inset-bottom, 0px);
	}

	/* 자동 저장 인디케이터 */
	@keyframes sb-spin { to { transform: rotate(360deg); } }
	.save-spinner { animation: sb-spin 0.7s linear infinite; }
	/* '저장됨'이 나타날 때 살짝 튀어오르며 페이드 인 → 저장이 방금 됐음을 눈으로 알아챈다 */
	@keyframes sb-pop {
		0% { opacity: 0; transform: scale(0.8); }
		60% { transform: scale(1.08); }
		100% { opacity: 1; transform: scale(1); }
	}
	.save-check { animation: sb-pop 0.28s ease-out; }
	/* 상태 텍스트가 바뀔 때 부드럽게 나타나도록(스피너↔체크↔자동저장 전환) */
	.save-indicator > span { animation: sb-fade 0.2s ease-out; }
	@keyframes sb-fade { from { opacity: 0; } to { opacity: 1; } }
	/* 게시 대기(미반영 변경) 점: 은은한 맥동으로 시선을 끈다. 접근성 위해 모션 최소화 설정은 존중 */
	@keyframes sb-pulse {
		0%, 100% { opacity: 1; transform: scale(1); }
		50% { opacity: 0.45; transform: scale(0.85); }
	}
	.publish-dot { animation: sb-pulse 1.6s ease-in-out infinite; }
	@media (prefers-reduced-motion: reduce) {
		.save-spinner, .save-check, .save-indicator > span, .publish-dot { animation: none; }
	}

	/* 새 빌더 셸: 상단 헤더(.builder-topbar = position:fixed, 56px) 아래를 꽉 채움.
	   헤더가 fixed라 흐름에서 빠져 있으므로 margin-top으로 밀어 겹침 방지. */
	.builder-shell {
		margin-top: 56px;
		height: calc(100vh - 56px);
		width: 100%;
		overflow: hidden;
		/* 캡된 콘텐츠 좌우 여백을 토큰 배경으로 채워 다크/라이트 동일하게 */
		background: hsl(var(--sb-background));
	}
	/* 크리퐁: 상단 네비바 없음 → 전체 높이 사용 */
	.builder-shell.creepong {
		margin-top: 0;
		height: 100vh;
	}

	.c-container.builder {
		top: 58px;
	}

	.c-container.builder.creepong {
		top: 0px;
	}

	/* 디바이스: 일반적인 모바일 사이즈(375×812, iPhone 기준) — Builder 프리뷰와 동일.
	   기존 webflow 매직넘버(베젤 370×690 / 화면 350×670 / iframe 360×676 overhang) 제거 →
	   화면=iframe이 프레임을 꽉 채운다. 얇은 테두리+라운드+그림자로 깔끔한 폰 실루엣.
	   좁은 화면에선 max-width:100% + aspect-ratio 로 비율 유지한 채 축소. */
	.mobile-frame {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		border: 0;
	}
	.preview-interface {
		width: 375px;
		max-width: 100%;
		aspect-ratio: 375 / 812;
		height: auto;
		flex-shrink: 0;
		padding: 0;
		border-radius: 40px;
		border: 1px solid hsl(var(--sb-border));
		background-color: hsl(var(--sb-card));
		box-shadow:
			0 22px 48px -20px rgba(0, 0, 0, 0.38),
			0 8px 20px -12px rgba(0, 0, 0, 0.22);
		overflow: hidden;
		position: relative;
	}
	.interface-wrap {
		display: flex;
		width: 100%;
		height: 100%;
		padding: 0;
		border-radius: 40px;
		overflow: hidden;
		background-color: hsl(var(--sb-card));
	}
	.image-153 {
		width: 320px;
	}
	.toggle {
		background-color: gray;
	}
	.toggle.on {
		background-color: #ff558d;
	}

	.text-block-104 {
		margin-left: 20px;
	}
	.text-block-104-copy {
		margin-left: 20px;
	}
	.div-block-121 {
		overflow: initial;
	}
	.c-builder-wrap {
		height: 100vh;
		overflow: scroll;
	}
	.chat-profileimage-con {
		height: 200px;
	}

	/* .chat-profileimage-con img {
		width: 200px;
	} */
	.chat-image-delete-btn {
		width: auto !important;
	}

	.icon-refresh {
		margin-top: 4px;
		cursor: pointer;
	}
	.preview-text {
		width: 370px;
	}
	.key-word {
		display: flex;
		flex-wrap: wrap; /* 요소들이 부모 요소 너비를 넘어가면 줄바꿈 */
		gap: 4px; /* 버튼들 사이의 간격 */
	}
	.keyword {
		margin-bottom: 4px;
		display: flex;
	}
	.autocorrect._2 {
		margin-bottom: 10px;
		white-space: nowrap;
		flex: 1 0 auto;
		max-width: 100%;
	}
	.delete-button {
		display: inline-block;
	}

	.universe {
		margin-bottom: 20px;
	}

	.key-word {
		margin-top: 8px;
	}
	.keyword-plus {
		margin-bottom: 4px;
	}
	.persona-keyword-wrapper {
		width: 100%;
	}
	.persona-wrap {
		margin-bottom: 10px;
	}
	.recommend-keyword-input {
		color: #fff;
		background-color: #686cdb;
		border-radius: 20px;
		margin-right: 8px;
		padding: 5px 10px;
		border: 1px;
		width: 120px;
	}

	.delete-button {
		background-image: url("/static/images/_keyword-x-button.svg");
	}

	.priority .keyword {
		background-color: #f7528a;
		color: white;
	}

	.overlay {
		display: none; /* 기본적으로 숨김 */
		position: fixed;
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		background-color: rgba(0, 0, 0, 0.5);
		z-index: 999;
	}

	.chat-contents-wrap {
		margin-right: 0px;
		justify-content: space-between;
	}

	.lite-preview-btn.create {
		background-image: none;
		color: white;
		font-size: 16px;
		border-radius: 30px;
		border: 1px solid rgba(255, 40, 109, 1);
		background-color: rgba(247, 82, 138, 1);
		justify-content: center;
		align-items: center;
		width: 190px;
		height: 50px;
		display: flex;
		position: fixed;
		box-shadow: 0 2px 19px 2px #313f695e;
		bottom: 100px;
		left: 50%;
		margin-left: 404px;
	}

	.preview-context {
		color: black;
	}

	.preview-button-wrapper {
		display: none;
	}

	.tooltip-builder {
		color: #fff;
		text-align: center;
		border-radius: 6px;
		background-color: #423f3f;
		font-family: "Noto sans kr 400", sans-serif;
		font-size: 12px;
		line-height: 12px;
		font-weight: 400;
		padding: 12px;
		position: fixed;
		z-index: 999;
		display: none;
		justify-content: center;
		left: 50%;
		margin-left: 404px;
		bottom: 160px;
	}

	.builder-btn-wrapper {
		position: fixed;
		height: 100px;
		bottom: 80px;
	}

	.chat-contents-wrap.last {
		padding: 10px;
	}

	.publishing-text {
		width: 96px;
	}

	.persona-option-wrap {
		margin-bottom: 0px;
	}

	.tab-list {
		display: flex;
		width: 100%;
		max-width: 900px;
		position: sticky;
		top: 0;
		z-index: 99;
		background-color: #fff;
	}

	.tab {
		flex: 1;
		text-align: center;
		padding: 14px 0;
		font-weight: 500;
		cursor: pointer;
		color: #666;
		transition: all 0.2s ease;
	}

	.tab:hover {
		background-color: #f9f9f9;
	}

	.tab.active {
		color: #000;
		border-bottom: 3px solid #007aff;
		font-weight: 600;
	}

	.label {
		font-size: 16px;
		font-weight: 500;
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	.required {
		color: red;
		font-size: 16px;
		line-height: 1;
	}

	.chat-con-wrap {
		margin-top: 0px;
		padding-top: 30px;
		padding-bottom: 0px;
	}

	.bottom-padding {
		height: 110px;
	}

	.link-section-header {
		display: flex;
		align-items: center;
		gap: 4px;
		line-height: 1;
	}

	.link-tooltip-wrapper {
		position: relative;
		display: flex;
		align-items: center;
	}

	.link-question-icon {
		width: 18px;
		height: 18px;
		cursor: pointer;
		flex-shrink: 0;
		display: block;
	}

	.link-tooltip-bubble {
		display: none;
		position: absolute;
		top: calc(100% + 8px);
		left: 50%;
		transform: translateX(-50%);
		background-color: #423f3f;
		color: #fff;
		font-size: 12px;
		line-height: 1.5;
		padding: 10px 12px;
		border-radius: 8px;
		width: 220px;
		z-index: 100;
		white-space: normal;
	}

	.link-tooltip-bubble::before {
		content: "";
		position: absolute;
		bottom: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 6px solid transparent;
		border-bottom-color: #423f3f;
	}

	.link-tooltip-wrapper:hover .link-tooltip-bubble {
		display: block;
	}

	.text-required {
		color: #6372ff;
	}

	@media screen and (min-width: 1280px) {
		.chat-con-wrap {
			padding-right: 20px;
		}
		.chat-contents-wrap.first {
			padding: 10px;
		}
	}

	@media screen and (max-width: 1990px) {
		.lite-preview-btn.create,
		.tooltip-builder {
			left: initial;
			margin-left: 680px;
		}
	}

	@media screen and (max-width: 1500px) {
		.lite-preview-btn.create,
		.tooltip-builder {
			left: initial;
			right: 94px;
			margin: 0;
		}
	}

	@media screen and (max-width: 1450px) {
		.lite-preview-btn.create,
		.tooltip-builder {
			right: 74px;
		}
	}

	@media screen and (max-width: 1279px) {
		.lite-preview-btn.create,
		.tooltip-builder {
			right: 24px;
		}
	}
	@media screen and (max-width: 991px) {
		.preview-button-wrapper.active {
			display: flex;
			position: fixed;
			right: 12px;
			top: 18px;
			z-index: 999;
		}

		.l-preview-wrap {
			display: none;
		}
		.l-preview-wrap.active {
			display: flex;
			position: fixed; /* 화면에 고정 */
			top: 0; /* 화면 상단에 맞춤 */
			left: 0; /* 화면 왼쪽에 맞춤 */
			width: 100%; /* 화면 너비를 100%로 설정 */
			height: 100%; /* 화면 높이를 100%로 설정 */
			background-color: rgba(
				0,
				0,
				0,
				0.5
			); /* 배경을 반투명 검은색으로 설정 */
			display: flex; /* 자식 요소들을 flex로 배치 */
			justify-content: center; /* 가로 방향으로 중앙 정렬 */
			align-items: center; /* 세로 방향으로 중앙 정렬 */
			z-index: 1000;
			padding: 0px;
		}

		/* (구) 모바일 전체화면 프레임 규칙 제거 — 새 반응형 드로어가 프리뷰 폰 목업을 그대로 렌더한다.
		   .preview-interface/.interface-wrap/.mobile-frame 을 position:fixed 100%로 덮으면 드로어와 충돌함. */
		.preview-text {
			display: none;
		}

		.lite-preview-btn {
			background-color: rgba(231, 233, 238, 1);
			border: 1px solid rgba(196, 196, 196, 1);
			border-radius: 10px;
			background-image: none;
			margin-left: 24px;
			width: 43%;
			color: black;
			bottom: calc(20px + var(--safe-bottom));
		}

		.lite-preview-btn.create {
			background-color: rgba(247, 82, 137, 1);
			background-image: none;
			border: 1px solid rgba(255, 127, 168, 1);
			margin-left: auto;
			margin-right: 24px;
			width: 43%;
			color: white;
			font-weight: 700;
			border-radius: 10px;
			inset: auto 0% 10%;
			bottom: calc(20px + var(--safe-bottom));
		}

		.builder-btn-wrapper {
			position: fixed;
			width: 100%;
			height: 100px;
			bottom: 70px;
		}

		.tooltip-builder {
			left: 50%;
			transform: translateX(-50%);
			width: 88%;
			bottom: 80px;
		}

		.chat-con-wrap > .first:nth-last-child(2) {
			margin-bottom: 160px;
		}
		.chat-con-wrap > .last {
			display: none;
		}
	}

	@media screen and (max-width: 767px) {
		.popup-layer {
			width: 100%;
			margin-right: 12px;
			margin-left: 12px;
		}
		.bring-image {
			width: 90%;
		}
		.category .item {
			font-size: 13px;
		}
		.category {
			flex: 0 0 31.3%;
		}
		.label {
			font-size: 15px;
		}
	}
	@media screen and (max-width: 479px) {
		.label {
			font-size: 14px;
		}

		.c-info-text-form {
			width: 100%;
		}
		.c-container.builder {
			display: flex;
			flex-direction: column;
			background-color: #ffffff;
		}

		.l-preview-wrap {
			width: 410px;
			padding-top: 0px;
			margin-left: auto;
			margin-right: auto;
		}

		.chat-contents-wrap.persona-option-wrap {
			margin-bottom: 0px;
		}
	}
</style>
